{
  "partnerPortal": {
    "addDevice": {
      "onp": {
        "no": "Non",
        "yes": "Oui",
        "yesHint": "Le client pourra saisir les informations de portage ultérieurement lors de l'activation de l'abonnement."
      },
      "quantity": {
        "decrement": "Diminuer la quantité",
        "increment": "Augmenter la quantité"
      },
      "rateSelection": {
        "dataTariffs": "Abonnements data",
        "flatHome": "Flat Home",
        "flatMobile": "Flat Mobile",
        "label": "Tarif",
        "required": "Veuillez sélectionner un abonnement pour continuer."
      },
      "step1": {
        "esim": {
          "description": "SIM numérique — aucune carte SIM requise."
        },
        "required": "Veuillez sélectionner un type de SIM pour continuer.",
        "simCard": {
          "description": "Pour les appareils avec emplacement SIM."
        },
        "step": "Étape 1"
      },
      "step4": {
        "checkingCustomer": "Vérification du compte client...",
        "existingCustomer": "Ce client est déjà enregistré chez Digital Republic. Les données personnelles ne doivent pas être saisies à nouveau.",
        "hint": "Demandez la pièce d’identité du client pour éviter les erreurs.",
        "hintTitle": "Conseil!"
      },
      "stepMenuLabel": "Aller à une autre étape",
      "steps": {
        "personal-details": {
          "description": "Saisissez les informations du client ou aidez-le pour la vérification d'identité.",
          "label": "Données client"
        },
        "quantity": {
          "description": "Combien d'abonnements avec la même configuration doivent être commandés ?",
          "label": "Nombre d'abonnements"
        },
        "sim-type": {
          "description": "Choisissez si le client recevra une carte SIM ou une eSIM.",
          "label": "Choisir le type de SIM"
        }
      },
      "submit": "Envoyer la commande",
      "submitting": "Envoi en cours…",
      "subtitle": "Ajoutez un abonnement pour un client."
    },
    "cockpit": {
      "callToAction": "Voir les abonnements",
      "description": "Découvrez nos abonnements actuels et conditions partenaires.",
      "heading": {
        "description1": "Bienvenue sur le portail des partenaires de distribution !",
        "description2": "Inscrivez-vous et attribuez une carte SIM aux clients ou aux nouveaux clients de Digital Republic.",
        "greeting": "Bonjour partenaires"
      },
      "mobileInternet": "Internet mobile pour tout et pour tous"
    },
    "success": {
      "addMorePlans": "Ajouter d'autres abonnements",
      "back": "Vers le cockpit",
      "existingCustomer": {
        "partnerSupport": {
          "hint": "Si la vérification d'identité n'est pas encore terminée, le client sera guidé lors de l'activation.",
          "list": {
            "1": "Se connecter au portail client avec ses identifiants existants",
            "2": "Ouvrir « À activer » dans le cockpit et sélectionner le nouvel abonnement",
            "3": "Terminer le processus d'activation"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "Le client peut recevoir un e-mail de confirmation",
            "2": "L'abonnement apparaît sous « À activer » dans le cockpit",
            "3": "Le client peut se connecter avec ses identifiants existants — aucune création de compte nécessaire"
          },
          "subtitle": "L'abonnement a été ajouté au compte client et attend d'être activé dans le portail client.",
          "title": "L'abonnement est prêt à être activé"
        }
      },
      "newCustomer": {
        "partnerSupport": {
          "hint": "Le client peut également effectuer ces étapes plus tard de manière autonome.",
          "list": {
            "1": "Ouvrir l'e-mail de bienvenue et définir un mot de passe",
            "2": "Se connecter au portail client",
            "3": "Terminer la vérification d'identité (ID check) avec son smartphone",
            "4": "Activer l'abonnement sous « À activer » dans le cockpit"
          }
        },
        "whatHappensNext": {
          "list": {
            "1": "Un lien pour définir son mot de passe",
            "2": "L'accès au portail client",
            "3": "Son nouvel abonnement, prêt à être activé"
          },
          "subtitle": "Le client recevra bientôt un e-mail de bienvenue avec tout ce dont il a besoin pour commencer.",
          "title": "Le client recevra un e-mail"
        }
      },
      "partnerSupport": {
        "subtitle": "Veuillez aider le client avec les étapes suivantes dans le portail client :",
        "title": "Aider le client à activer son abonnement"
      },
      "successMessage": "Commande envoyée avec succès !"
    },
    "welcomeScreen": {
      "animationText": "Let’s get started, welcome!",
      "descriptionText": "Activez des eSIM et des cartes SIM pour vos clients. Consultez \n<0>nos abonnements ici</0>. Digital Republic active les eSIM en quelques minutes, sans aucun temps d'attente.",
      "title": "Se connecter"
    }
  },
  "portal": {
    "Error": {
      "eSimError": "Les informations eSIM n'ont pas pu être chargées. Veuillez réessayer plus tard."
    },
    "add-device": {
      "blockedModal": {
        "viewBills": "Voir les factures"
      },
      "deleteBasket": {
        "title": "Votre sélection sera complètement supprimée"
      },
      "esimInfoModal": {
        "benefits": {
          "instant": "Activation immédiate sans attendre une carte SIM",
          "multiTariff": "Plusieurs abonnements possibles sur un même appareil",
          "noSwap": "Pas besoin de changer de carte SIM"
        },
        "confirm": "Générer une eSIM",
        "description": "Une eSIM (embedded SIM) est une carte SIM numérique intégrée à votre appareil. Vous n'avez plus besoin de carte SIM.",
        "requirementText": "Votre appareil doit être compatible eSIM (p. ex. iPhone XS ou plus récent, Samsung Galaxy S20 ou plus récent).",
        "requirementTitle": "Condition",
        "title": "Qu'est-ce qu'une eSIM ?"
      },
      "heading": "Ajouter un abonnement",
      "invalidBasket": {
        "confirm": "Recommencer",
        "description": "Votre panier actuel n'est plus valide. Nous le supprimons et recommençons le processus.",
        "title": "Panier non valide"
      },
      "overflowMenuLabel": "Plus d'actions",
      "simSelection": {
        "generateEsimLink": "Pas de carte SIM ? Générer une eSIM directement",
        "reasons": {
          "IDCheckOpen": "Votre vérification d'identité n'est pas encore terminée.",
          "TooManySIMs": "Vous avez atteint le nombre maximum de cartes SIM."
        }
      },
      "steps": {
        "checkout": {
          "description": "Vérifiez vos informations avant de terminer l'intégration.",
          "label": "Récapitulatif"
        },
        "number-porting": {
          "description": "Le portage de votre numéro suisse depuis votre ancien fournisseur est gratuit et uniquement possible avec l'un de nos abonnements Flat Mobile.",
          "label": "Conserver votre numéro"
        },
        "rate-selection": {
          "label": "Choix de l'abonnement"
        },
        "sim-selection": {
          "label": "Type de SIM"
        }
      },
      "subheading": "Ajoutez un autre abonnement à votre Cockpit en activant une carte SIM ou une eSIM.",
      "success": {
        "fraudCheckInfo": "Nous vérifions vos informations. Cela devrait prendre quelques minutes. Vous devrez ensuite effectuer la vérification d'identité.",
        "info": "Nous préparons la prochaine étape pour votre nouvelle SIM.",
        "title": "Merci pour votre commande !"
      }
    },
    "authenticator": {
      "app": {
        "setup": {
          "step1": {
            "copied": "J'ai copié votre code QR.",
            "copy-error": "Erreur lors de la copie de votre code QR.",
            "description": "Si vous ne l'avez pas encore fait, téléchargez une application Authenticator. Pour une liste des applications prises en charge et des instructions de configuration détaillées, veuillez consulter notre <FAQ />. Après avoir installé l'application, ouvrez-la et utilisez l'application pour scanner le code QR affiché.",
            "enter-key-manually": "Saisir la clé manuellement",
            "faqOn2faApps": "FAQ sur les applications 2FA",
            "faqUrl": "https://support.digitalrepublic.ch/fr/support/solutions/articles/33000290333",
            "show-qr-code": "Afficher le code QR",
            "title": "1. Scannez le code QR",
            "your-manual-key": "Votre clé manuelle :"
          },
          "step2": {
            "description": "Après avoir scanné le code QR ou saisi manuellement la clé, votre application génère un code de confirmation à 6 chiffres. Saisissez-le ci-dessous pour terminer la configuration.",
            "invalidCode": "Code invalide",
            "title": "2. Saisissez le code de vérification"
          }
        }
      },
      "backupCodes": {
        "copy": "Copier les codes",
        "copyError": "Échec de la copie des codes.",
        "copySuccess": "Codes copiés avec succès !",
        "description": "Dans la boîte ci-dessous, vous trouverez vos codes de récupération personnels. Vous aurez besoin de ces codes si vous perdez votre appareil avec l'application Authenticator ou si vous n'y avez plus accès. Veuillez noter ces codes ou les télécharger et les conserver en lieu sûr.   \n \nLes codes vous permettent de restaurer votre compte ou de configurer une application Authenticator sur votre nouvel appareil. Chaque code ne peut être utilisé qu'une seule fois.",
        "download": "Télécharger les codes",
        "downloadSuccess": "Codes téléchargés avec succès !",
        "error": "Erreur lors de la confirmation de votre 2FA. \nEssayer à nouveau.",
        "nameRequired": "S'il vous plaît entrez votre nom.",
        "nameWrong": "Veuillez signer avec votre nom enregistré.",
        "proceedWithSteps": "Procédez aux étapes suivantes",
        "steps": {
          "1": {
            "description": "Assurez-vous d'avoir copié et stocké en toute sécurité vos codes de sécurité uniques dans un endroit sûr auquel vous seul pouvez accéder.",
            "title": "1. Copiez et enregistrez vos codes en toute sécurité."
          },
          "2": {
            "placeholder": "Tapez “{{name}}” pour confirmer",
            "title": "2. Confirmez que vous avez sauvegardé vos codes de récupération en utilisant votre nom."
          }
        },
        "success": "Configurez avec succès l’authentification à deux facteurs.",
        "title": "Vous y êtes presque !",
        "uniqueRecoveryCodes": "Codes de récupération personnels"
      },
      "sms": {
        "enterNumber": {
          "description": "Veuillez indiquer le numéro de téléphone mobile que vous souhaitez utiliser pour recevoir le SMS contenant vos codes de vérification.",
          "label": "Numéro de téléphone portable",
          "sendCode": "envoyer le code",
          "title": "Saisissez votre numéro de téléphone portable"
        },
        "verification": {
          "description": "Un code a été envoyé au {{number}}. Saisissez le code ci-dessous pour confirmer votre numéro de téléphone mobile et terminer la configuration.",
          "digit": "Chiffre {{index}} sur {{count}}",
          "label": "Code de vérification",
          "resend": "Renvoyer le code",
          "resendToast": {
            "error": "Erreur lors de l'envoi du code. \nEssayer à nouveau.",
            "success": "Code envoyé avec succès."
          },
          "secondsLeft": "dans {{count}} secondes",
          "title": "Entrer le code de vérification"
        }
      },
      "verifyEmail": {
        "confirmCode": "Confirmer le code",
        "confirmEmailAddress": "Vérifiez votre adresse e-mail",
        "description": "Pour terminer votre inscription, nous devons vérifier votre adresse e-mail. Veuillez saisir le code que nous avons envoyé à {{email}}.",
        "enterEmailAgain": "Saisir à nouveau l'adresse e-mail",
        "error": {
          "invalidCode": "Code invalide",
          "maxCodes": "Nombre maximal de codes actifs atteint",
          "maxRetry": "Nombre maximal de tentatives de vérification atteint"
        },
        "success": "Adresse e-mail vérifiée avec succès",
        "successResend": "Code envoyé",
        "wrongMailAddress": "L'adresse e-mail est-elle incorrecte?"
      }
    },
    "bills": {
      "downloadMultiple": "Télécharger plusieurs",
      "download_many": "télécharger {{count}}",
      "download_one": "télécharger",
      "download_other": "télécharger {{count}}",
      "list": {
        "downloadBill": "Télécharger la facture",
        "empty": "Il n'y a pas encore de factures.",
        "headline": "Vos factures",
        "status": {
          "canceled": "Annulé",
          "due": "Ouverte",
          "paid": "Payé",
          "reminder": "Rappel"
        },
        "tableHeaders": {
          "amount": "Montant",
          "date": "Date",
          "deselectAllBills": "Désélectionner toutes les factures sur cette page.",
          "invoiceFor": "Facture",
          "number": "Numéro de facture",
          "open": "Ouvrir",
          "selectAllBills": "Sélectionner toutes les factures sur cette page."
        }
      },
      "zipName": "{{count}} factures de Digital Republic"
    },
    "bulk-sim-activation": {
      "activationFailed": "Échec de l'activation",
      "csvError": "Le CSV doit contenir les colonnes ICCID, PUK et Alias (p. ex. Inv | ICCID, PUK 1, Alias).",
      "csvFile": "Fichier CSV",
      "customer": {
        "email": "E-mail",
        "heading": "Utilisateur connecté",
        "id": "Numéro client",
        "loading": "Chargement du client...",
        "notAvailable": "n/d",
        "paymentMode": "Mode de paiement",
        "unknown": "Client inconnu"
      },
      "description": "Téléverse un CSV et lance l'activation des SIM une par une via les points de terminaison d'onboarding.",
      "heading": "Activation SIM en masse",
      "manualPaymentRequired": {
        "description": "L'activation est réservée aux clients dont le mode de paiement est Manuel.",
        "title": "Paiement manuel requis"
      },
      "startActivation": "Démarrer l'activation ({{count}} en attente)",
      "status": {
        "failed": "Échec",
        "pending": "En attente",
        "running": "En cours",
        "success": "Réussi"
      },
      "steps": {
        "addBasketEntry": "ajout d'une entrée au panier",
        "addOption": "ajout de l'option",
        "checkSim": "vérification de la SIM",
        "checkout": "paiement",
        "idle": "en file d'attente",
        "saveBasket": "récupération du panier",
        "setAlias": "définition de l'alias",
        "setDevice": "définition de l'appareil",
        "setICCID": "définition ICCID/PUK"
      },
      "stopAfterCurrent": "Arrêter après la ligne en cours",
      "table": {
        "alias": "Alias",
        "empty": "Aucune donnée CSV chargée."
      }
    },
    "cockpit": {
      "dashboard": {
        "quickLinks": {
          "showAll": "Tout afficher",
          "showMoreAbos_many": "",
          "showMoreAbos_one": "+{{count}} abonnement supplémentaire",
          "showMoreAbos_other": "+{{count}} abonnements supplémentaires",
          "title": "Vos abonnements"
        },
        "resources": {
          "fwb": {
            "button": "Inviter des amis",
            "text": "Invitez vos amis et économisez jusqu’à 30% sur vos abonnements."
          }
        },
        "todos": {
          "addPaymentMethod": "Ajoutez un moyen de paiement",
          "fwbMobileAbo": "Souscrivez un abo mobile pour rester dans votre groupe d'amis",
          "kyc": {
            "dataMismatch": "Corrigez vos données selon votre pièce d'identité",
            "errorProcessingDocs": "Téléchargez à nouveau votre pièce d'identité",
            "errorProcessingSelfie": "Refaites votre vidéo selfie",
            "fraudCheckPending": "Votre commande est en cours de vérification",
            "idUncomparable": "Relancez votre vérification d'identité",
            "invalidDocument": "Téléchargez une pièce d'identité valide",
            "maxAttempts": "Contactez le support",
            "open": "Vérifiez votre identité",
            "pending": "Votre identité est en cours de vérification",
            "underaged": "Vérifiez les conditions d'âge"
          },
          "payOpenBills": "Réglez vos factures impayées",
          "title": "À faire"
        }
      },
      "deviceList": {
        "noSearchResults": "Votre recherche n'a donné aucun résultat.",
        "row": {
          "green": "Cet abonnement est actif.",
          "grey": "Cet abonnement est inactif.",
          "openDevice": "Ouvrir {{alias}}",
          "red": "Cet abonnement a été bloqué.",
          "yellow": "Cet abonnement est actif et est mis en pause."
        }
      },
      "filter": {
        "activity": "Activité",
        "activity-labels": {
          "all": "Tous",
          "mobileAbo": "Abonnement mobile"
        },
        "additionalColumns": "Colonnes supplémentaires",
        "application": "Type de SIM",
        "apply": "appliquer des filtres",
        "dropdowns": {
          "chooseColumns": "Choisir des colonnes",
          "column": "Colonne",
          "simType": {
            "placeholder": "Type de SIM"
          }
        },
        "openFilters": "Ouvrir les filtres",
        "resetFilters": "Réinitialiser les filtres",
        "searchBar": {
          "placeholder": "Saisir la recherche",
          "toggle": "Ouvrir la recherche"
        },
        "status-labels": {
          "activeLimited": "En cours de pause",
          "onpPending": "Numéro de portage en cours"
        },
        "title": "Filtre"
      },
      "heading": {
        "greeting": "Bonjour {{name}} !"
      },
      "id-banner": {
        "open": {
          "button": "Vers la vérification d'identité"
        }
      },
      "idCheck": {
        "button": "Vers la vérification d'identité",
        "info": "Selon la législation suisse, nous devons vérifier votre identité avant d'activer votre SIM. Merci de vérifier les conditions requises et les informations ci-dessous avant de commencer la vérification d'identité.",
        "infoFromOrder": "Selon la législation suisse, nous devons vérifier votre identité avant d'activer votre nouvelle SIM. Merci de vérifier les conditions requises et les informations ci-dessous avant de commencer la vérification d'identité.",
        "internationalCallsWarning": "Les appels depuis et vers l'étranger ne sont autorisés qu'avec un document suisse (passeport, carte d'identité ou permis sauf N) et une adresse en Suisse enregistrée.",
        "prep": {
          "noTablets": "Les tablettes ne sont pas prises en charge",
          "privacy": "Nous traitons vos données avec soin et conformément au droit suisse",
          "recommendedBrowsers": "Système d'exploitation à jour (Safari ou Chrome)",
          "validIdDocument": "Pièce d'identité valide"
        },
        "title": "Vérification d'identité",
        "titleFromOrder": "Dernière étape pour votre nouvelle SIM"
      },
      "kycSection": {
        "idCheckFailed": {
          "text": "Vos données n'ont pas pu être vérifiées. Veuillez télécharger à nouveau votre pièce d'identité.",
          "title": "Échec de l'ID Check"
        },
        "links": {
          "maxAttempts": "https://support.digitalrepublic.ch/fr/support/tickets/new",
          "underaged": "https://support.digitalrepublic.ch/fr/support/solutions/articles/33000269430-puis-je-%C3%A9galement-souscrire-un-abonnement-pour-mon-enfant-mineur-"
        }
      },
      "managementTile": {
        "details": {
          "sections": {
            "autoRenewal": {
              "buttons": {
                "confirm": "Confirmer"
              },
              "disable": {
                "description_many": "Après le <strong>temps restant de {{count}} journées</strong>, cet abonnement ne sera plus renouvelé automatiquement:",
                "description_one": "Après le <strong>temps restant d'un jour</strong>, cet abonnement sera mis en pause : ",
                "description_other": "Après le <strong>temps restant de {{count}} jours</strong>, cet abonnement ne sera plus renouvelé automatiquement:",
                "goodToKnow": "Vous pouvez le réactiver à tout moment.",
                "successMessage": "Votre abonnement sera mis en pause.",
                "successorWarning": "Le pack consécutif que vous avez sélectionné auparavant <strong>{{ flatName }}</strong> ne sera pas activé.",
                "title": "Mettre l'abonnement en pause"
              },
              "enable": {
                "description": "L'abonnement suivant se poursuit <strong>tous les {{days}} jours</strong> : ",
                "nextBillDescription": "Votre abonnement sera facturé à partir du mois prochain. Vous ne payez rien aujourd'hui.",
                "title": "Réactiver l'abonnement"
              }
            },
            "details": {
              "changeEsim": {
                "qrCodeDone": "Votre profil eSIM a été créé. Dans 5 à 10 minutes, vous recevrez un e-mail contenant le code QR correspondant. Veillez à activer ce code sur votre appareil final dans les 24 heures.",
                "qrCodeTitle": "Scanner le QR Code",
                "waitingText": "Votre eSIM est en cours de création, cela prendra quelques minutes. Le code QR s'affichera dès qu'il aura été créé."
              },
              "deviceDetails": "Détails de l'abonnement",
              "esimHint": "Activez cette carte SIM en eSIM",
              "installOnThisDevice": {
                "title": "Installer l'eSIM sur cet appareil"
              },
              "instructionsLinkText": "Afficher les instructions",
              "networkReset": {
                "confirmationText": "Si vous avez des problèmes de réseau avec votre SIM, il peut être utile de la réinitialiser et de la redémarrer. <0>Après avoir confirmé l'action, nous recommandons:</0>",
                "error": "La réinitialisation n'a pas été lancée avec succès",
                "label": "Reset réseau",
                "link": "Reset",
                "reasons": {
                  "openEsimChange": "Votre profil eSIM est en cours de transfert, veuillez patienter.",
                  "openEsimReset": "Votre profil eSIM est en cours de rechargement, veuillez patienter.",
                  "openNetworkReset": "Une réinitialisation réseau est déjà en cours, veuillez patienter.",
                  "openONP": "Votre numéro est en cours de portage.",
                  "openOrder": "Un autre processus est en cours, veuillez patienter.",
                  "openSpeedAndLock": "Actuellement impossible, veuillez patienter.",
                  "simCancelled": "Votre forfait a été annulé.",
                  "simInactive": "Votre carte SIM est inactive.",
                  "simLocked": "Votre carte SIM est bloquée.",
                  "simTerminated": "Votre carte SIM sera terminée."
                },
                "recommendations": {
                  "reboot": "redémarrez votre appareil",
                  "rebootWatchSim": "si vous avez enregistré une WatchSIM, redémarrez également cet appareil",
                  "remove": "dans le cas d'une carte SIM physique, retire-la de l'appareil et remets-la en place",
                  "wait": "d'attendre 15 minutes avant que les améliorations ne se produisent"
                },
                "success": "La réinitialisation a été lancée avec succès.",
                "text": "Si vous avez des problèmes de réseau avec votre SIM, il peut être utile de la réinitialiser et de la redémarrer.",
                "title": "Dépannage"
              },
              "reasons": {
                "StatusNotAllowed": "Vous devez supprimer votre eSIM de votre appareil avant d'effectuer cette opération.",
                "noAutoRenew": "L'abonnement est en pause.",
                "noMoreActions": "Nombre maximum d'eSIM (conversion eSIM).",
                "packageOrderInProgress": "Une commande de forfait est déjà en cours.",
                "simFixedService": "La carte SIM a un type de service fixe.",
                "simInactive": "La carte SIM est inactive.",
                "simNoActivePackage": "Aucun pack actif réservé.",
                "simSuspended": "La carte SIM est temporairement bloquée.",
                "simTerminated": "Le contrat a été résilié.",
                "wrongSimType": "Mauvais type de carte SIM."
              },
              "registrationDetails": {
                "activationCode": "Code d'activation",
                "addressCopied": "Adresse SM-DP+ copiée !",
                "addressCopyError": "L'adresse SM-DP+ n'a pas pu être copiée.",
                "codeCopied": "Code d'activation copié !",
                "codeCopyError": "Le code d'activation n'a pas pu être copié.",
                "completeActivationCode": "Code d'activation complet",
                "completeCodeCopied": "Code d'activation complet copié !",
                "completeCodeCopyError": "Le code d'activation complet n'a pas pu être copié.",
                "hideCode": "Masquer le code",
                "infoText": "Copiez le code et saisissez-le manuellement dans votre appareil pour activer votre eSIM.",
                "invalidCode": "Le code d'activation de cette eSIM n'est pas valide.",
                "missingMatchingId": "Aucun code d'activation n'est actuellement disponible pour cette eSIM.",
                "showCode": "Entrer le code manuellement",
                "smdpPlusAdress": "Adresse SM-DP+"
              },
              "reloadEsim": {
                "button": "Recharger",
                "screens": {
                  "confirm": {
                    "text": "Êtes-vous sûr de vouloir réactiver votre eSIM ? <br><br>Vous pourrez ensuite reconnecter votre eSIM dans les paramètres réseau de votre appareil. <br><br>Vous trouverez plus d'informations sur l'activation d'une eSIM sur notre portail d'assistance.",
                    "title": "Recharger l'eSIM"
                  }
                },
                "text": "Si vous avez supprimé votre profil eSIM sur votre appareil, vous pouvez en charger un nouveau ici.",
                "title": "Recharger le profil eSIM"
              },
              "scanQRCode": "Scannez le code QR",
              "scanQRCodeText": "Scannez votre code QR pour activer définitivement cet appareil et profiter de tous les avantages.",
              "simDetails": "Détails SIM",
              "switchFromPhysicalToEsim": {
                "screens": {
                  "confirm": {
                    "text": "Vous avez une carte SIM dans votre appareil et souhaitez passer à l'eSIM ?<br><br>Assurez-vous que votre appareil est <0>Compatible eSIM</0> puis passez à une eSIM en un clic.",
                    "title": "Passer à l'eSIM"
                  }
                }
              },
              "transferEsim": {
                "button": "Transférer",
                "screens": {
                  "confirm": {
                    "text": "Êtes-vous sûr de vouloir activer votre eSIM sur un nouvel appareil <br><br>Notez que l'eSIM sur l'appareil actuel sera immédiatement désactivée. <br><br>Vous trouverez plus d'informations sur l'activation d'une eSIM sur notre portail d'assistance.",
                    "title": "Transférer eSIM"
                  }
                },
                "text": "Ici, vous pouvez transférer votre profil eSIM vers un nouvel appareil.",
                "title": "Transférer le profil eSIM"
              }
            }
          }
        },
        "roaming": {
          "addOption": {
            "countryDropdownLabel": "Destination",
            "countryList": "Tous les forfaits sont valables 365 jours. Consultez-les <0/> ici.",
            "errorWait": "La réservation n'est pas possible pour le moment. Patientez quelques minutes avant de réessayer.",
            "noPackagesForDestination": "Aucun forfait d'itinérance n'est disponible pour cette destination.",
            "packagesTitle": "Packs roaming",
            "selectCountryHint": "Choisissez votre pays de destination pour filtrer les packs d'itinérance appropriés",
            "selectPackageHint": "Choisissez directement le pack roaming souhaité.",
            "stepLabel": "Choix du pack",
            "title": "Ajouter le roaming",
            "volume": "Volume de données"
          },
          "card": {
            "bookedPackagesTitle": "Forfaits réservés",
            "dataUsageGeneric": "Consommation de données",
            "mobileAboTitle": "Inclus dans votre abonnement",
            "noActivePackage": "Aucun forfait roaming actif",
            "selectPackage": "Choisir un forfait"
          },
          "checkout": {
            "internationalCallPermissionHint": {
              "description": "Actuellement, vous n'avez pas accès aux minutes d'appel incluses vers l'étranger. Pour pouvoir les utiliser, vous devez enregistrer une pièce d'identité délivrée en Suisse dans votre compte client (passeport, carte d'identité, permis C, B, F ou S). Si vous possédez un tel document, vous pouvez l'enregistrer via notre service d'assistance. Vous pouvez déjà utiliser les données de roaming incluses, même sans ce document d'identité.",
              "title": "Fonctions d'itinérance restreintes"
            },
            "once": "Unique",
            "roamingOption": "Option d'itinérance",
            "stepLabel": "Conclusion",
            "success": "Réservation terminée avec succès.",
            "title": "Réserver le roaming"
          },
          "inAdditionToSubscription": "En plus de votre abonnement :",
          "includedInSubscription": "Inclus dans votre abonnement :",
          "package": "Forfait {{index}}",
          "roamingCallHint": {
            "text": "Les appels depuis la Suisse vers l'étranger ne sont inclus que pour les pays suivants : Andorre, Belgique, Danemark, Allemagne, Îles Féroé, Finlande, France, Gibraltar, Grèce, Groenland, Guernesey, Irlande, Islande, Île de Man, Italie, Jersey, Canada, Liechtenstein, Luxembourg, Malte, Monaco, Pays-Bas, Norvège, Autriche, Portugal, Saint-Marin, Suède, Espagne, États-Unis, Vatican, Royaume-Uni, Chypre.",
            "title": "Appels de Suisse à l'étranger"
          },
          "showOption": {
            "active": {
              "callsToAndFromAbroad": "Appels UE/USA",
              "dataUsage": "Données UE/États-Unis",
              "notAllowed": "Actuellement pas disponible.",
              "notAllowedTooltip": "Pour utiliser la téléphonie en itinérance, un moyen de paiement doit être enregistré et un document d'identité délivré en Suisse (passeport/carte d'identité ou permis de séjour) doit être utilisé lors de l'ID Check.",
              "overspentCalls": "Vos appels internationaux sont épuisés et les <0>tarifs normaux</0> s'appliquent.",
              "overspentCallsLink": "https://digitalrepublic.ch/wp-content/uploads/2024/05/Preisliste_FR-2.pdf",
              "remainingData": "<0>{{value}}</0> de <0>{{initial}} MB</0> disponibles",
              "remainingDataGB": "<0>{{value}}</0> de <0>{{initial}} Go</0> disponibles",
              "remainingMin": "<0>{{value}}</0> sur <0>{{initial}} min</0> disponibles",
              "runtimeUsage": "<0>{{value}}</0> de <0>{{initial}} jours</0> restants",
              "unlimitedCalls": "Appels internationaux illimités"
            },
            "flatMobileHint": {
              "notIncluded": "non inclus",
              "renewalReminder": "Le volume de données en itinérance se renouvelle le premier jour du mois.",
              "text": "comme votre volume de données en itinérance inclus est toujours renouvelé le 1er du mois, vous recevez votre volume de données en itinérance proportionnel le premier mois.",
              "title": "Volume de données en itinérance partiel premier mois"
            },
            "flatMobileTooltip": {
              "example": {
                "description": "Activation le 15 janvier : Vous recevrez 50% du volume de données en itinérance pour janvier et 100% à partir de février.",
                "title": "Exemple "
              },
              "monthlyRenewal": {
                "description": "Votre volume d'itinérance est renouvelé chaque mois le 1er, quelle que soit la date d'activation de votre abonnement.",
                "title": "Renouvellement mensuel "
              },
              "proRataVolume": {
                "description": "Le premier mois, vous recevrez votre volume de données d'itinérance au prorata.",
                "title": "Volume au pro-rata le premier mois "
              },
              "title": "Informations sur le volume de données en itinérance inclus"
            },
            "inactive": {
              "hint": "Chaque pack de données roaming est valable 365 jours et n'est activé que lorsque vous êtes à l'étranger.<br><br>Si votre abonnement comprend les appels et les SMS, vous pouvez activer la téléphonie et les SMS à l'étranger dans <0>Appels</0>."
            },
            "ordered": {
              "usage": "Votre forfait roaming est en préparation."
            },
            "ready": {
              "daysLeft": "Encore <0>{{days}}</0> sur <0>{{initial}} jours</0> pour l'activer",
              "daysLeftWithoutTotal": "Encore <0>{{days}} jours</0> pour l'activer",
              "firstPackageOfUsageZone": {
                "subtitle": "Commence dès que vous êtes à l'étranger."
              },
              "notFirstPackageOfUsageZone": {
                "subtitle": "Commence dès que les paquets précédents de la zone sont utilisés."
              }
            }
          }
        },
        "subscription": {
          "chooseSubscription": "Choisir un abonnement",
          "noSubscription": "Aucun abonnement actif",
          "options": {
            "changeDisabled": "Les options de l’abonnement ne peuvent être modifiées qu’une fois la commande terminée.",
            "changeDisabledMissingPaymentMean": "Votre abonnement ne peut être modifié qu’après l’ajout d’un moyen de paiement.",
            "changeDisabledPauseReview": "Les options de l’abonnement ne peuvent être modifiées qu’une fois cette pause confirmée ou annulée.",
            "changeDisabledWatchSim": "Les options de l’abonnement ne peuvent être modifiées qu’une fois la Watch SIM activée.",
            "dataRoaming": "Données en itinérance UE/USA",
            "download": "Download",
            "upload": "Upload"
          },
          "price": {
            "title": "Prix de base de l’abonnement"
          },
          "status": {
            "billingPeriod": {
              "change": "Changer",
              "label": "Période de facturation"
            },
            "cancelPause": "Annuler la pause",
            "changeDisabled": "Le statut de l’abonnement ne peut être modifié qu’une fois la commande terminée.",
            "changeDisabledFlatHome": "À partir du {{date}}, vous pouvez gérer le statut de votre abonnement Flat Home. Flat Home a une durée contractuelle minimale de 12 mois.",
            "changeDisabledWatchSim": "L’abonnement ne peut être mis en pause qu’une fois la Watch SIM activée.",
            "inPreparation": "L’abonnement est en préparation",
            "locked": "Votre abonnement est bloqué",
            "pause": "Mettre l’abonnement en pause",
            "pausing": "Mise en pause le <0>{{date}}</0>",
            "paymentFailed": {
              "text": "Votre abonnement se poursuit dès que vous avez mis à jour <0>votre moyen de paiement</0>.",
              "title": "Paiement échoué"
            },
            "title": "Statut de l’abonnement"
          },
          "successor": "Passez à {{flatName}}",
          "successorOn": "Passez le <0>{{date}}</0> à {{flatName}}",
          "title": "Votre abonnement"
        },
        "tabs": {
          "abo": "Abonnement",
          "details": "Détails",
          "disabledHint": {
            "inactive": "Vous ne pouvez pas ouvrir cet onglet, car vous avez besoin d’un abonnement actif.",
            "lockRequested": "Vous pourrez ouvrir cet onglet dès que votre abonnement ne sera plus bloqué.",
            "numberPorting": "Vous pourrez gérer votre abonnement dès que la portabilité du numéro sera terminée.",
            "servicePending": "Vous pourrez ouvrir cet onglet dès que votre abonnement sera prêt."
          },
          "numberPorting": {
            "keepNumberQuestion": "Souhaitez-vous conserver votre numéro de téléphone actuel et demander la portabilité maintenant ?",
            "title": "Portabilité du numéro",
            "warning": "Vous <0>ne pourrez pas</0> choisir cette option plus tard."
          },
          "roaming": "Roaming",
          "voice": "Appels"
        },
        "tariff": {
          "autoRenew": "Mettre l'abonnement en pause",
          "changeDisabledReasons": {
            "flatHome": {
              "hint": "(Flat Home a une durée minimale d'engagement de 12 mois)",
              "text": "À partir du <strong>{{date}}</strong>, vous pouvez mettre en pause votre abonnement Flat Home.",
              "title": "Informations sur la mise en pause"
            }
          },
          "checkout": {
            "aliasNotSaved": "Votre abonnement a été modifié, mais le nom « {{alias}} » n'a pas pu être enregistré. Vous pouvez le modifier à nouveau sous Détails.",
            "aliasSaveFailed": "Le nom de l'abonnement n'a pas pu être enregistré. Veuillez réessayer.",
            "creditText": "(temps restant)",
            "creditTextOthers": "(autres)",
            "noProductId": "Revenez en arrière et sélectionnez un produit.",
            "tariffActivation": {
              "asSuccessor_many": "Au bout <strong> de {{count}} jours</strong>, cet abonnement sera activé automatiquement :",
              "asSuccessor_one": "Après le <strong>temps restant d'un jour</strong>, cet abonnement sera activé automatiquement :",
              "asSuccessor_other": "Au bout <strong> de {{count}} jours</strong>, cet abonnement sera activé automatiquement :",
              "now_many": "Le temps restant de {{count}} jours vous sera crédité. Dès que vous aurez donné votre confirmation, le montant sera débité de votre mode de paiement et l'abonnement <strong>immédiatement</strong> activé :",
              "now_one": "Le temps restant d'une journée vous sera crédité. Dès que vous aurez confirmé, votre moyen de paiement sera débité et l'abonnement sera activé <strong>immédiatement</strong> :",
              "now_other": "Le temps restant de {{count}} jours vous sera crédité. Dès que vous aurez donné votre confirmation, le montant sera débité de votre mode de paiement et l'abonnement <strong>immédiatement</strong> activé :",
              "now_zero": "Dès que vous aurez donné votre confirmation, le montant sera débité de votre mode de paiement et l'abonnement <strong>immédiatement</strong> activé :"
            },
            "watchSimDeactivationHint": "Si vous passez à un abonnement data uniquement, <0>votre Watch SIM sera désactivée</0>. La Watch SIM n'est disponible qu'avec un abonnement comprenant les appels et les SMS.",
            "watchSimWarning": "Avertissement"
          },
          "goodToKnow": {
            "inactiveHint": "Vous pouvez réactiver votre abonnement à tout moment dans un délai de 12 mois.",
            "missingPaymentMeanHint": "Votre abonnement se poursuivra dès que vous ajoutez un <0>moyen de paiement</0>.",
            "numberPorting": "Votre abonnement sera activé dès que la portabilité du numéro sera terminée.",
            "warning": "Avertissement"
          },
          "once": "une seule fois",
          "payInterval": "Tous les {{days}} jours",
          "serviceIsPendingHint": "Votre abonnement est en cours d'activation. Cette opération peut prendre jusqu'à 15 minutes. Si le délai d'attente vous semble trop long, veuillez contacter le service client.",
          "until": "jusqu'au",
          "untilRevoke": "jusqu'à révocation",
          "yourTariff": "Votre abonnement"
        },
        "voiceSettings": {
          "errors": {
            "changeInProgress": "Une modification des appels est déjà en cours de traitement. Merci de réessayer plus tard."
          },
          "reasons": {
            "askSupport": "En cas de questions, n'hésitez pas à contacter notre équipe d'assistance.",
            "costLimitReached": "La limite des coûts a été dépassée.",
            "creditClassC": "Cette action n’est pas disponible pour les clientes et clients qui n’ont pas téléchargé un document d’identité délivré en Suisse ou qui ne sont pas résidents en Suisse.",
            "noActiveVoicePackage": "Cette fonction n’est pas disponible pour les abonnements en données seules.",
            "noPaymentMean": "Aucun mode de paiement enregistré.",
            "servicePendingBlocked": "Les paramètres d'appel ne peuvent pas être modifiés tant qu'une commande pour cette SIM est encore en cours de traitement.",
            "voiceSettingsBlocked": "Certains paramètres d'appel sont verrouillés pour la raison suivante :"
          },
          "settings": {
            "adult": {
              "subtitle": "Service payant de divertissement pour adultes à valeur ajoutée. ",
              "title": "Divertissement adulte"
            },
            "roaming": {
              "subtitle": "Les appels vers l'étranger ainsi que depuis la Suisse vers l'étranger sont payants selon la <0>liste des tarifs</0>.",
              "title": "Roaming et appels internationaux"
            },
            "serviceNumbers": {
              "subtitle": "Appels payants vers les numéros 0906 et 090x",
              "title": "Numéro de service à valeur ajoutée"
            },
            "serviceSMS": {
              "subtitle": "Messages de service à valeur ajoutée payants",
              "title": "Service à valeur ajoutée SMS"
            },
            "voiceBox": {
              "subtitle": "Les appels manqués sont renvoyés vers la boîte vocale. Si vous vous trouvez à l'étranger, cette fonction peut engendrer des frais.",
              "title": "Boîte vocale"
            }
          }
        },
        "watchSim": {
          "autoRenewal": {
            "disable": {
              "description_many": "Après le <strong>temps restant de {{count}} jours</strong>, cet abonnement ne sera plus renouvelé automatiquement : ",
              "description_one": "Après le <strong>temps restant d'un jour</strong>, cet abonnement sera mis en pause : ",
              "description_other": "Après le <strong>temps restant de {{count}} jours</strong>, cet abonnement ne sera plus renouvelé automatiquement : ",
              "goodToKnowText": "Vous pouvez le réactiver à tout moment.",
              "successMessage": "Votre abonnement sera mis en pause."
            },
            "enable": {
              "description": "L'abonnement suivant se poursuit <strong>tous les {{count}} jours</strong> : ",
              "goodToKnowText": {
                "withMainSimAR": "Veuillez noter que la Watch SIM ne fonctionne qu'avec un abonnement principal actif. Si votre abonnement principal est en pause, il sera également réactivé en conséquence."
              },
              "nextBillDescription": "Votre Watch SIM sera facturée à partir du prochain mois de facturation. Vous ne payez rien aujourd'hui.",
              "title": "Réactiver la Watch SIM"
            }
          },
          "checkout": {
            "autoRenewal": {
              "hint_many": "Le <0>temps restant de {{count}} jours</0> vous sera crédité. Dès que vous aurez confirmé, votre moyen de paiement sera débité et l'abonnement sera activé immédiatement :",
              "hint_one": "Le <0>temps restant d'un jour</0> vous sera crédité. Dès que vous aurez confirmé, votre moyen de paiement sera débité et l'abonnement sera activé immédiatement :",
              "hint_other": "Le <0>temps restant de {{count}} jours</0> vous sera crédité. Dès que vous aurez confirmé, votre moyen de paiement sera débité et l'abonnement sera activé immédiatement :",
              "message": "Votre abonnement reste actif. Vous pouvez gérer vos paramètres à tout moment."
            },
            "confirm": "Confirmer la réservation",
            "creditRemainingTime": "Avoir (durée restante)",
            "title": "Ajouter une Watch",
            "today": "Aujourd'hui"
          },
          "display": {
            "autoRenew": "Mettre la Watch SIM en pause",
            "creationHelpText": "Cette option vous permet de relier votre smartwatch à votre smartphone. Veuillez vous assurer que vos appareils peuvent être reliés avant de réserver.",
            "linkHelpText": "Pour relier votre smartwatch à votre smartphone, veuillez suivre les instructions figurant sur votre smartwatch ou <0>ici</0>.",
            "linkHelpUrl": "https://support.digitalrepublic.ch/fr/support/solutions/folders/33000217141",
            "noActiveOption": "Aucune Watch SIM active",
            "pending": "Votre Watch SIM sera bientôt prête à être activée.",
            "title": "Votre Watch SIM",
            "voiceOption": "Voice Option",
            "voiceOptionNeeded": "La Watch SIM ne peut être souscrite qu'avec un abonnement Flat Mobile actif."
          },
          "status": {
            "activating": "En cours de préparation",
            "cancelPause": "Annuler la suspension",
            "changeDisabled": "Le statut de la Watch SIM ne peut être modifié qu’une fois la commande terminée.",
            "locked": "Votre Watch SIM est bloquée",
            "pause": "Suspendre la Watch SIM",
            "pausing": "le <0>{{date}}</0>",
            "title": "Statut de la Watch SIM"
          }
        }
      },
      "purchaseIntent": {
        "esim": {
          "button": "Activer l'eSIM",
          "message": "Activez votre eSIM sans attendre et profitez de votre abonnement."
        },
        "physical": {
          "button": "Activer la carte SIM",
          "defaultAlias": "Carte SIM",
          "message": "Dès que votre carte SIM sera arrivée, vous pourrez l'activer ici."
        },
        "status": {
          "onTheWay": "Carte SIM en route"
        }
      },
      "sections": {
        "toActivate": "À activer"
      }
    },
    "common": {
      "alerts": {
        "agentLogin": "Connecté en tant qu'agent",
        "error": "L'action a échoué.",
        "tryAgain": "Réessayer"
      },
      "autoRenewal": {
        "dueDate": "Facture due le {{date}}",
        "goodToKnow": "Vous pouvez mettre votre abonnement en pause ou le résilier à tout moment.",
        "nextBillTitle": "Votre prochaine facture :",
        "successMessage": "Votre abonnement est de nouveau actif."
      },
      "bills": "Factures",
      "buttons": {
        "abort": "interrompre",
        "bookOption": "Réserver un forfait",
        "cancel": "annuler",
        "change": "modifier",
        "clearSearch": "Effacer la recherche",
        "close": "fermer",
        "confirm": "confirmer",
        "continue": "continuer",
        "disable": "désactiver",
        "enable": "permettre",
        "save": "sauvegarder",
        "showOptions": "Afficher les options",
        "skipForLater": "Plus tard",
        "submit": "envoyer",
        "switch": "changer"
      },
      "checkout": {
        "creditOther": "Avoir (autres)",
        "nowToPay": "À payer maintenant",
        "paymentMethod": "Moyens de paiement",
        "paymentMethodHint": "Si vous souhaitez choisir un autre moyen de paiement, modifiez-le dans les <0>paramètres</0> de la gestion de votre compte.",
        "paymentMethodSubtitle": "Moyens de paiement déjà enregistrés",
        "sum": "Somme"
      },
      "device": {
        "attributes": {
          "deviceType": "Type d'appareil",
          "followupPackage": "Abonnement suivant",
          "iccid": "ICCID",
          "mobileSubscription": "Abonnement mobile",
          "openRuntime": "Durée",
          "pin": "PIN",
          "puk": "PUK",
          "roamingDataConsumption": "Consommation de données en itinérance",
          "roamingOpenRuntime": "Durée en itinérance",
          "roamingStatus": "Statut d'itinérance",
          "simNumber": "Numéro SIM",
          "simType": "Type de SIM",
          "status": "Statut",
          "tariff": "Abonnement",
          "telephoneNumber": "Numéro de téléphone",
          "voiceOption": "Option Voice"
        },
        "placeholder": {
          "alias": "Mon abonnement"
        }
      },
      "esim": {
        "install": "Installer l'eSIM",
        "installHint": "Appuyez sur le bouton pour installer votre eSIM.",
        "profile": "Profil eSIM"
      },
      "listOfData": {
        "error": "Une erreur s'est produite lors du chargement.",
        "noMoreData": "Toutes les cartes SIM ont été chargées."
      },
      "nextBill": "Prochaine facture le <0>{{date}}</0>",
      "openBillReason": "Vous avez au moins une facture qui n'a pas encore été réglée.",
      "or": "ou",
      "phoneNumber": "Numéro de téléphone",
      "roaming": {
        "countryList": "Liste des pays",
        "dialog": {
          "title": "Zones de données d'itinérance et pays"
        },
        "zones": {
          "ZONE1": "EU/USA",
          "ZONE2": "zone 2",
          "ZONE3": "zone 3",
          "ZONE4": "Dans tous les autres pays, aucun service d'itinérance n'est proposé.",
          "countries": {
            "ZONE1": "Andorre, Autriche, Belgique, Bulgarie, Canada, Croatie, Chypre, République tchèque, Danemark, Estonie, Îles Féroé, Finlande, France, Allemagne, Gibraltar, Grèce, Groenland, Guernesey, Hongrie, Islande, Irlande, Île de Man, Italie, Jersey, Lettonie, Liechtenstein, Lituanie, Luxembourg, Malte, Monaco, Pays-Bas, Norvège, Pologne, Porto Rico, Portugal, Roumanie, Saint-Marin, Suède, Slovaquie, Slovénie, Espagne, Turquie, Hongrie, USA, Vatican, Royaume-Uni.",
            "ZONE2": "Afrique du Sud, Albanie, Algérie, Australie, Bosnie-Herzégovine, Brésil, Israël, Kosovo, Macédoine, Maroc, Mexique, Monténégro, Oman, Palestine, Qatar, République dominicaine, Serbie, Singapour, Thaïlande, Égypte, Émirats arabes unis.",
            "ZONE3": "Afghanistan, Anguilla, Antigua-et-Barbuda, Antilles françaises, Antilles néerlandaises, Argentine, Arménie, Azerbaïdjan, Bahamas, Bangladesh, Barbade, Bermudes, Biélorussie, Botswana, Brunei Darussalam, Burkina Faso, Bénin, Cambodge, Cameroun, Cap-Vert, Chili, Chine, Colombie, Congo-Brazzaville, Corée du Sud, Costa Rica, Cuba, Côte d'Ivoire, Dominique, Fidji, Fédération Russe, Grenade, Guadeloupe, Guatemala, Guinée, Guinée-Bissau, Guyane, Guyane Française, Géorgie, Haïti, Honduras, Hong Kong, Inde, Indonésie, Irak, Iran, Jamaïque, Japon, Kenya, Kirghizistan, Koweït, Laos, Le Salvador, Libéria, Madagascar, Malaisie, Malawi, Mali, Martinique, Maurice, Mozambique, Nicaragua, Niger, Nigeria, Nouvelle-Zélande, Népal, Ouganda, Ouzbékistan, Pakistan, Panama, Paraguay, Philippines, Polynésie française, Pérou, Rwanda, République de Moldavie, République démocratique du Congo, Saint Barthélemy, Saint Martin (partie française), Saint-Christophe-et-Niévès, Saint-Vincent-et-les-Grenadines, Sainte-Lucie, Seychelles, Sierra Leone, Soudan, Soudan du Sud, Sri Lanka, Sénégal, Taïwan, Tchad, Trinité-et-Tobago, Tunisie, Ukraine, Uruguay, Vietnam, Zambie, Équateur, Île de la Réunion, Îles Caïmans, îles Turques-et-Caïques, Îles Vierges des États-Unis."
          }
        }
      },
      "status": {
        "active": "Actif",
        "inactive": "Inactif",
        "notAvailable": "Non disponible",
        "suspended": "Bloqué"
      },
      "stepLabels": {
        "rateSelection": "Sélection de l'abonnement"
      },
      "stepMenuLabel": "Passer à une autre étape",
      "subscriptionCount_one": "{{count}} abonnement",
      "subscriptionCount_other": "{{count}} abonnements",
      "tooltip": {
        "actionNotPossible": {
          "text_many": "Vous ne pouvez pas utiliser cette fonction pour les raisons suivantes :",
          "text_one": "Vous ne pouvez pas utiliser cette fonction pour la raison suivante :",
          "text_other": "Vous ne pouvez pas utiliser cette fonction pour les raisons suivantes :",
          "title": "Actuellement impossible"
        },
        "moreInfo": "Plus d'informations"
      }
    },
    "documents": {
      "tabItemizedBill": {
        "additionalSelectedNumbers_many": "",
        "additionalSelectedNumbers_one": "et {{count}} autre numéro sélectionné",
        "additionalSelectedNumbers_other": "et {{count}} autres numéros sélectionnés",
        "btnSearch": "Rechercher",
        "choosePlanAndPeriod": "Veuillez sélectionner un numéro de téléphone et une période pour consulter votre aperçu des connexions.",
        "headline": "Vos relevés de communications",
        "noItemizedBillOverview": "Il n'existe pas encore d'aperçu des connexions des six derniers mois.",
        "onlyOneFilterAllowed": "Un seul filtre autorisé",
        "placeholderPeriods": "Sélectionnez la période",
        "placeholderPlans": "Sélectionnez le numéro de téléphone",
        "placeholderSearchTerm": "Rechercher un numéro",
        "resultsHeadline": "Résultat de la recherche",
        "subtitle": "Souhaitez-vous obtenir un aperçu de vos appels téléphoniques et SMS ? Veuillez télécharger le récapitulatif de vos communications des 6 derniers mois au format PDF.",
        "title": "Aperçu des connexions",
        "zipName": "Détail des communications - Digital Republic"
      }
    },
    "flatHome": {
      "duration": "Durée de 12 mois"
    },
    "friendsWithBenefits": {
      "creatingGroup": "Création de votre groupe...",
      "error": {
        "fail": "Erreur lors de la création du groupe"
      },
      "groupName": "Nouveau Groupe de Amis",
      "groupOverview": {
        "confirmLeave": "Quitter",
        "discount": "rabais",
        "eligibleProducts": "Abonnements",
        "groupTitle": "Friends with Benefits de {{name}}",
        "groupTitleSEnding": "Friends with Benefits de {{name}}",
        "howItWorks": "Voici comment ça fonctionne",
        "howItWorksModal": {
          "changingSubscriptionAnswer": "Le rabais est déduit lors du paiement. Par exemple, si vous souscrivez un nouvel abonnement ou si le renouvellement automatique est activé, le rabais applicable à ce moment-là s'applique. Si vous ajoutez un nouvel abonnement, il est immédiatement pris en compte dans le calcul de votre rabais, ce qui vous permet de bénéficier immédiatement d'une offre encore plus avantageuse.",
          "changingSubscriptionQuestion": "Comment fonctionne le rabais si je modifie mes abonnements ?",
          "eligibleSubscriptionsAnswer": "Chaque abonnement mobile Flat Mobile de Digital Republic est pris en compte pour votre rabais. Cela signifie également que vous bénéficiez d'une rabais si vous avez plusieurs abonnements Flat Mobile actifs sur votre compte.\n\nVeuillez noter que les abonnements ne bénéficient du rabais que si un moyen de paiement valide est enregistré sur le compte client correspondant.",
          "eligibleSubscriptionsQuestion": "Quels abonnements sont concernés par le rabais ?",
          "flatMobileInactiveAnswer": "Si vous ne disposez pas encore d'un forfait Flat Mobile actif, vous pouvez tout de même rejoindre un groupe Friends with Benefits.\n\nToutefois, après 30 jours sans abonnement payant, vous serez automatiquement retiré du groupe afin de libérer la place.",
          "flatMobileInactiveQuestion": "Que se passe-t-il si je ne dispose pas encore d'un forfait Flat Mobile actif ?",
          "joinMoreGroupsAnswer": "Non, vous ne pouvez appartenir qu'à un seul groupe à la fois. Si vous souhaitez rejoindre un autre groupe, vous devez d'abord quitter votre groupe actuel.",
          "joinMoreGroupsQuestion": "Puis-je rejoindre plusieurs groupes ?",
          "maxMemberLimitExceededAnswer": "Chaque groupe peut compter jusqu'à 15 membres. Une fois votre groupe complet, aucun autre membre ne peut le rejoindre. Le lien d'invitation informe les nouveaux utilisateurs que le groupe a atteint son nombre maximal de membres, vous n'avez donc pas besoin de gérer cela manuellement.",
          "maxMemberLimitExceededQuestion": "Que se passe-t-il lorsque mon groupe atteint le nombre maximal de membres ?",
          "numberPortingInProgressAnswer": "Bonne nouvelle ! Si votre numéro est encore en cours de transfert vers Digital Republic, vous pouvez rester dans le groupe jusqu'à ce que le transfert soit terminé.\n\nVeuillez noter que votre abonnement ne sera pris en compte pour le rabais qu'une fois le transfert terminé et votre abonnement activé.",
          "numberPortingInProgressQuestion": "Que faire si mon numéro est encore en cours de transfert ?"
        },
        "inactiveWarning": "<0>Avis !</0><br />Aucun abonnement actif. Ce membre sera automatiquement supprimé dans {{days}} jours si aucun produit éligible n'est ajouté.",
        "inviteFriends": "Inviter des amis",
        "leaveTribe": "Quitter le groupe ?",
        "leaveTribeConfirmationText": "Si vous quittez ce groupe, vous ne bénéficierez plus de votre remise de groupe. Vous pourrez toutefois créer un nouveau groupe ou en rejoindre un autre à tout moment.",
        "leaveTribeConfirmationTitle": "Quitter le groupe ?",
        "linkCopied": "Lien copié !",
        "linkCopyError": "Le lien n'a pas pu être copié.",
        "members": "{{count}} membre",
        "members_other": "{{count}} membres",
        "newFriend": "Nouvel ami",
        "onpHint": "La réduction ne sera appliquée à l'abonnement qu'une fois le transfert du numéro effectué",
        "orderFM": "Commander Flat Mobile",
        "share": "Partager l'invitation",
        "sharePanel": {
          "email": "E-mail",
          "subtitle": "Partager via...",
          "title": "Partagez le code et invitez vos amis"
        },
        "shareSubHeadline": "Voulez-vous économiser avec moi ? <br />( ) Oui ( ) Non ( ) Peut-être",
        "shareText": "Chez Digital Republic, nous profitons jusqu'à 30 % sur les abonnements illimités de téléphonie mobile à partir de CHF 13.",
        "shareTitle": "Rejoignez Friends with Benefits | Digital Republic",
        "status": {
          "discountTitle": "Vous bénéficiez d'un <0>rabais de {{percentage}}</0> !",
          "fullDescription": "Bravo, vous avez tellement de « Friends with Benefits » que vous avez atteint la <0>limite du groupe</0>.",
          "fullMaxDescription": "Bravo, vous avez tellement de « Friends with Benefits » que vous avez atteint la <0>limite</0>.",
          "fullMaxTitle": "Félicitations ! Votre groupe est complet et vous bénéficiez d'un <0>rabais de {{percentage}}</0> !",
          "fullTitle": "Votre groupe est complet et vous bénéficiez d'un <0>rabais de {{percentage}}</0> !",
          "maxDiscount": "Félicitations ! Vous et vos amis avez ainsi atteint le <0>rabais maximal</0>.",
          "nextLevel_many": "",
          "nextLevel_one": "Ajoutez <0>{{count}} membre ou appareil supplémentaire</0> pour atteindre le niveau suivant de <1>{{nextPercentage}} de rabais</1>.",
          "nextLevel_other": "Ajoutez <0>{{count}} membres ou appareils supplémentaires</0> pour atteindre le niveau suivant de <1>{{nextPercentage}} de rabais</1>."
        },
        "subheading": "Peu importe ce qui vous lie, vous économisez.",
        "tableTitle": "Vos amis"
      },
      "joinGroup": {
        "error": {
          "alreadyInGroup": "Vous êtes déjà Friends with Benefits avec d'autres personnes. Restez-leur fidèle ou quittez le groupe avant de rejoindre un nouveau groupe.",
          "deletedGroup": "Ces Friends with Benefits se sont volatilisés. Créez un nouveau groupe ou rejoignez-en un existant.",
          "notFound": "Ces «Friends with Benefits» n'ont pas pu être trouvés. Peut-être une faute de frappe dans le lien ?",
          "paymentMethod": "Malheureusement, ce moyen de paiement n'est pas pris en charge.",
          "tribeFull": "Il n'y a malheureusement plus de place ici. Mais vous pouvez créer un nouveau groupe Friends with Benefits !"
        },
        "sucess": "Vous avez rejoint le groupe avec succès !"
      },
      "newGroup": {
        "createButton": "Créer le groupe",
        "footer": "Vous connaissez déjà quelqu'un qui a un groupe ? Demandez le lien d'invitation et c'est parti !",
        "notificationDescription": "Avec chaque abonnement Flat Mobile supplémentaire dans votre groupe, le rabais augmente. Économisez jusqu'à 30 % sur votre abonnement Mobile.",
        "notificationTitle": "Jusqu'à <0>30 % de rabais</0> !",
        "steps": {
          "1": "Créez votre groupe en un clic.",
          "2": "Envoyez, postez ou partagez votre lien d'invitation comme et où vous le souhaitez.",
          "3": "Tout le monde peut rejoindre le groupe <0>et</0> inviter d'autres personnes"
        },
        "subtitle": "{{name}}, sécurisez un rabais pour vous et vos amis",
        "title": "Nouveau groupe"
      },
      "welcome": {
        "benefits": {
          "instant": {
            "text": "Les abonnements activés profitent immédiatement de chaque nouveau palier de rabais.",
            "title": "Profiter tout de suite"
          },
          "saving": {
            "text": "Plus le groupe est grand, plus le rabais est élevé – jusqu’à 30% sont possibles.",
            "title": "Économiser ensemble"
          },
          "viral": {
            "text": "Chaque membre peut en inviter d’autres – peu importe où vous publiez le lien.",
            "title": "Devenir viral"
          }
        },
        "discountShort": "Votre rabais : {{discount}}%",
        "flatMobileOne": "Flat Mobile One",
        "flatMobileThree": "Flat Mobile Three",
        "flatMobileTwo": "Flat Mobile Two",
        "greeting": "Bienvenue!",
        "joinNow": "Rejoignez maintenant",
        "link": "https://digitalrepublic.ch/fr/informations-clients-fwb/",
        "nextSteps": "Comment obtenir votre avantage",
        "notConvinced": "D’autres questions? <0>En savoir plus sur Friends with Benefits et nos offres</0>",
        "priceHint": "Vous obtenez ainsi l’abonnement forfaitaire le moins cher pour la Suisse pour seulement CHF {{price}} par mois! Plus il y a d’abonnements dans le groupe, plus le rabais est élevé pour tout le monde!",
        "rates": "Nos abonnements",
        "referralCTA": "Vous bénéficiez ainsi d'abonnements mobiles sans frais d'activation et sans durée minimale. Avec Digital Republic, entièrement sans engagement.",
        "slides": {
          "aboutMe": "À propos de moi",
          "counter": "{{step}} / {{total}}",
          "goToSlide": "Aller à la slide {{step}}",
          "lastSlide": {
            "cta": "Je suis partant·e !",
            "headline": "C’est à vous, passez à l’étape suivante!",
            "notification": {
              "description": "Jusqu’à 30% de rabais pour tout le monde!",
              "title": "Plus de Friends with Benefits"
            },
            "steps": {
              "invite": "Invitez d’autres amis",
              "save": "Faites encore baisser le prix pour vous et pour les autres."
            },
            "title": "C'est à vous de jouer !"
          },
          "pauseSlides": "Pause",
          "resumeSlides": "Reprendre",
          "searchingFor": "À la recherche de:",
          "selectSlide": "Choisir la slide",
          "slide1": {
            "bullet1": "Abonnements mobiles flexibles sans frais cachés",
            "bullet2": "Tout illimité en Suisse",
            "description": "Je suis Digital Republic – juste, simple et flexible. Aucun engagement, aucun coût caché – avec moi, vous savez toujours à quoi vous en tenir. Je suis fait pour vous si vous aimez la liberté et ne voulez pas vous engager.",
            "match": "Clientes et clients qui aiment la liberté, l’équité et le progrès."
          },
          "slide2": {
            "bullet1": "Tout illimité en Suisse, y compris la 5G",
            "bullet2": "3 Go de données en roaming dans la zone UE/USA",
            "bullet3": "30 minutes d'appels en roaming dans la zone UE/USA",
            "description": "Je suis l'abonnement terre-à-terre. Un peu de roaming, pas de fioritures, juste ce dont vous avez vraiment besoin. Je suis votre partenaire idéal si la Suisse vous suffit, avec un petit contingent pour les voyages à l'étranger.",
            "match": "Les économes et les minimalistes",
            "title": "Flat Mobile One | CHF 13.–"
          },
          "slide3": {
            "bullet1": "Tout illimité en Suisse, y compris la 5G",
            "bullet2": "20 Go de données en roaming dans la zone UE/USA",
            "bullet3": "100 minutes d'appels en roaming dans la zone UE/USA",
            "description": "Je suis aussi spontané que votre quotidien, qui vous emmène parfois au-delà des frontières suisses. Je suis l'abonnement qu'il vous faut si vous appréciez la vitesse, ne souhaitez pas vous engager, mais souhaitez tout de même pouvoir jeter un œil (surfer ou téléphoner) de l'autre côté de la frontière.",
            "match": "Les spontanés et les décontractés",
            "title": "Flat Mobile Two | CHF 18.–"
          },
          "slide4": {
            "bullet2": "50 Go de données en roaming dans la zone UE/USA",
            "bullet3": "Appels illimités en roaming dans la zone UE/USA",
            "description": "Je suis pour ceux qui en veulent plus, sans limite. Commencez sans hésiter. Avec moi, vous bénéficiez d'un accès illimité à l'Internet haut débit en Suisse et vous surfez et téléphonez au-delà des frontières nationales. Je suis l'abonnement sans compromis.",
            "match": "Les libres et les sans compromis",
            "title": "Flat Mobile Three | CHF 25.–"
          },
          "slide5": {
            "bullet1": "Vous permet de garder votre numéro de mobile",
            "bullet2": "Résilie votre contrat auprès de votre ancien opérateur.",
            "description": "Les ruptures ne sont jamais faciles. C'est pourquoi nous vous aidons à mettre fin à votre relation avec votre ancien opérateur. Tout ce dont j'ai besoin, c'est de votre numéro et du nom de votre ancien fournisseur. 😉",
            "match": "La rupture simple",
            "title": "Portabilité du numéro"
          }
        },
        "steps": {
          "benefit": "Profitez de jusqu'à 30 % de rabais",
          "order": "Choisissez votre abonnement Flat Mobile",
          "register": "Rejoignez Friends with Benefits"
        },
        "stories": "Faites connaissance avec Digital Republic",
        "textFlatMobileOne": "CH illimité, 3 Go & 30 min Roaming",
        "textFlatMobileThree": "CH illimité, 50 Go & illimité min Roaming",
        "textFlatMobileTwo": "CH illimité, 20 Go & 100 min Roaming",
        "unknown": "quelqu'un",
        "youWereInvited": "Quelle chance ! Vous avez été invité·e par <0>{{user}}</0> à rejoindre Friends with Benefits."
      }
    },
    "layout": {
      "header": {
        "menu": {
          "logout": "Se déconnecter"
        }
      },
      "menu": {
        "bottomNav": {
          "ariaLabel": "Navigation inférieure"
        },
        "burger": {
          "close": "Fermer la navigation",
          "open": "Ouvrir la navigation"
        },
        "items": {
          "account": "Compte",
          "accountAriaLabel": "Compte utilisateur",
          "cockpit": "Cockpit",
          "documentsAriaLabel": "Factures et documents",
          "friendsWithBenefitsShort": "FwB",
          "mySubscriptions": "Abonnements"
        },
        "sidebar": {
          "ariaLabel": "Navigation principale",
          "collapse": "Réduire la navigation",
          "expand": "Développer la navigation"
        }
      },
      "skipToContent": "Aller au contenu principal",
      "table": {
        "pageNumberComboBox": {
          "entriesPerPage": "Lignes par page"
        },
        "pagination": {
          "ariaLabel": "Pagination"
        },
        "sortBy": "Trier par {{title}}"
      },
      "tiles": {
        "activeSim": {
          "internationalCalls": "Appels UE/États-Unis",
          "notAvailable": "non disponible",
          "roamingCallUsage": "{{remaining}} / {{available}} min disponibles",
          "roamingUsage": "{{remaining}} / {{available}} Mo disponibles",
          "roamingUsageGB": "{{remaining}} / {{available}} Go disponibles"
        },
        "addDevice": {
          "button": "Ajouter un abonnement maintenant",
          "title": "Ajoutez un nouvel abonnement !"
        },
        "complete": "Compléter",
        "evnCard": {
          "button": "Voir maintenant",
          "text": "Comprenez mieux vos factures grâce à un aperçu détaillé de vos appels et SMS.",
          "title": "Aperçu"
        },
        "inactive": {
          "activateSubscriptionButton": "Activer l'abonnement",
          "activateSubscriptionText": "Sélectionnez un nouvel abonnement sous « Activer l'abonnement » pour cet appareil.",
          "activateText": "Sélectionnez un nouvel abonnement sous <0>Gérer l'abonnement</0> pour cet appareil.",
          "beginsAfterID": "Commence après le contrôle d'identité",
          "noPackageActive": "Aucun pack de données actif",
          "noSubscriptionActive": "aucun abonnement activé"
        },
        "numberPorting": {
          "numberBeingTransferred": "Le numéro est en cours de transfert",
          "sections": {
            "dateBeingIdentified": "La date de portage est fixée",
            "done": "Le portage est terminé",
            "known": "Le portage a lieu le {{val}}",
            "missingInformation": "Il manque des informations",
            "requested": "Le portage a été demandé",
            "simActivationPending": "Activation de la carte SIM en attente"
          }
        },
        "pending": {
          "chipLabel": "En préparation",
          "couldNotRenewTitle": "N'a pas pu être poursuivi.",
          "inProcess": "Votre abonnement est en cours de préparation",
          "missingPaymentMethod": "Votre abonnement n'a pas pu être poursuivi, car aucun moyen de paiement n'est enregistré."
        },
        "promoItemizedBill": {
          "activateNow": "Voir maintenant",
          "heading": "Aperçu des connexions",
          "text": "Comprenez mieux vos factures avec l'aperçu détaillé de vos appels et SMS."
        },
        "qrCodeTile": {
          "activateText": "Scannez ce code QR avec votre smartphone pour installer votre eSIM.",
          "inProcessText": "Votre profil eSIM est en cours de création. Cela peut durer quelques minutes. ",
          "instructionsLink": "https://support.digitalrepublic.ch/fr/support/solutions/articles/33000277288-comment-activer-une-esim-sur-mon-smartphone-",
          "qrPerEMail": "Le code QR correspondant s'affichera ensuite ici et vous sera envoyé par e-mail.",
          "showInstructions": "Voir les instructions"
        },
        "statusChip": {
          "pausing": "Sera suspendu"
        },
        "suspendedSim": {
          "yourSimSuspended": "Votre carte SIM a été bloquée."
        }
      }
    },
    "loading": "Charge en cours...",
    "mobileAbo": {
      "name": "Roaming",
      "roamingGoodToKnow": "Le volume de données en itinérance inclus dans votre abonnement mobile appartient à la Zone 1 et sera toujours utilisé en premier, même si vous avez déjà activé des options d'itinérance supplémentaires dans la même zone.",
      "roamingGoodToKnowMinuteAllowance": "Votre crédit de minutes est mis à jour avec un délai pouvant aller jusqu'à 24 heures. Les minutes d'appel qui dépassent votre crédit seront facturées à la minute."
    },
    "my-subscriptions": {
      "addSubscription": "Ajouter un abonnement",
      "viewToggle": {
        "list": "Vue en liste",
        "tiles": "Vue en mosaïque"
      }
    },
    "personalDataOnboarding": {
      "headline": "Complétez votre profil"
    },
    "subscription-change": {
      "currentTariffLabel": "Actuel",
      "heading": "Modifier l'abonnement",
      "steps": {
        "checkout": {
          "label": "Commande"
        }
      }
    },
    "user-account": {
      "billingAccounts": {
        "add": "Ajouter un destinataire",
        "bulkMove": {
          "description": "Déplacez plusieurs abonnements d'un destinataire de facture vers un autre en une seule fois.",
          "deselectAll": "Désélectionner tous les abonnements",
          "error": "Nous n'avons pas pu déplacer les abonnements. Merci de réessayer.",
          "selectAll": "Sélectionner tous les abonnements",
          "selectHeadline": "1. Choisir les abonnements",
          "selected": "Abonnements sélectionnés",
          "success": "Les abonnements ont été déplacés.",
          "targetDescription": "Après le déplacement, les abonnements sélectionnés seront attribués à ce destinataire de facture.",
          "targetHeadline": "2. Destinataire de facture cible",
          "title": "Déplacement groupé"
        },
        "details": {
          "address": "Adresse",
          "note": "Remarque",
          "postalAddress": "Adresse postale"
        },
        "empty": "Vous n'avez pas encore ajouté de destinataire de facture.",
        "expand": "Afficher les détails",
        "modal": {
          "create": "Créer le destinataire",
          "createSuccess": "Le destinataire de facture a été créé.",
          "createTitle": "Ajouter un destinataire de facture",
          "description": "Indiquez le nom, l'adresse, l'e-mail et la référence de ce destinataire de facture.",
          "editAddress": "Modifier",
          "editTitle": "Modifier le destinataire de facture",
          "error": "Nous n'avons pas pu enregistrer le destinataire de facture. Merci de réessayer.",
          "fields": {
            "additionalAddress": "Complément d'adresse",
            "alias": "Désignation",
            "aliasHint": "Apparaît dans l'aperçu après le numéro de destinataire de facture pour que vous puissiez attribuer le destinataire plus rapidement.",
            "city": "Localité",
            "companyName": "Nom de l'entreprise",
            "companyOrNameRequired": "Veuillez indiquer un nom d'entreprise ou un nom.",
            "email": "Adresse e-mail",
            "emailHeadline": "E-mail*",
            "firstName": "Prénom",
            "lastName": "Nom",
            "note": "Ajouter une remarque",
            "referenceHeadline": "Référence*",
            "zip": "NPA"
          },
          "updateSuccess": "Le destinataire de facture a été enregistré."
        },
        "move": {
          "source": "Source",
          "submit": "Déplacer les abonnements",
          "target": "Choisir le destinataire de facture cible"
        },
        "moveModal": {
          "error": "Nous n'avons pas pu déplacer l'abonnement. Merci de réessayer.",
          "subscription": "Abonnement à déplacer",
          "success": "L'abonnement a été déplacé.",
          "title": "Déplacer l'abonnement"
        },
        "picker": {
          "listHeadline": "Vos destinataires de facture",
          "title": "Choisir le destinataire de facture"
        },
        "reference": "Référence",
        "select": {
          "label": "Destinataire de facture"
        },
        "subscriptions": {
          "empty": "Aucun abonnement n'est attribué à ce destinataire de facture.",
          "headline": "Abonnements attribués",
          "move": "Déplacer l'abonnement",
          "moveSelected_one": "Déplacer {{count}} abonnement",
          "moveSelected_other": "Déplacer {{count}} abonnements"
        }
      },
      "inbox": {
        "contactlanguage": "Langue de contact",
        "marketingSubtitle": "Je souhaite recevoir des offres spéciales par e-mail.",
        "marketingTitle": "Informations supplémentaires",
        "noLanguageSet": "Aucune langue sélectionnée.",
        "saveError": "Nous n'avons pas pu enregistrer vos modifications. Veuillez réessayer."
      },
      "paymentMethods": {
        "addPaymentMethod": "Ajouter",
        "cancel": "Annuler",
        "change": "Modifier",
        "changeSuccessAlert": "Le mode de paiement a été modifié avec succès.",
        "confirmDelete": "Je confirme que je souhaite supprimer irrévocablement mon moyen de paiement",
        "delete": "effacer",
        "deletePaymentmean": "Supprimer le moyen de paiement",
        "deleteSuccessAlert": "Votre mode de paiement a été supprimé avec succès.",
        "errorAlerts": {
          "generalErrorAlert": "Votre mode de paiement n'a pas pu être supprimé. Réessayez ou adressez-vous à l'équipe d'assistance.",
          "openBill": "Votre moyen de paiement n'a pas pu être supprimé car une ou plusieurs factures n'ont pas encore été réglées.",
          "outstandingCharges": "Votre moyen de paiement n'a pas pu être supprimé car la facturation de vos frais n'est pas encore terminée. En cas de questions, adressez-vous à l'équipe d'assistance",
          "payAsYouGo": "Votre moyen de paiement n'a pas pu être supprimé car la facturation de vos frais n'est pas encore terminée. En cas de questions, adressez-vous à l'équipe d'assistance.",
          "serviceSettingsOn": "Votre mode de paiement n'a pas pu être supprimé. Des frais qui n'ont pas encore été facturés sont liés à votre compte. En cas de questions, adressez-vous à l'équipe d'assistance."
        },
        "headline": "Vos moyens de paiement",
        "invoice": "Facture",
        "noPaymentMethod": "Vous n'avez enregistré aucun moyen de paiement.",
        "requestPaymentViaInvoice": "Si vous souhaitez demander un paiement par facture, cliquez sur <0>ce lien</0>.",
        "requestPaymentViaInvoiceLink": "https://support.digitalrepublic.ch/en/support/tickets/new?ticket_form=firmenkunden_%2F_business_client",
        "title": "Modes de paiement"
      },
      "personalDetails": {
        "address": "Adresse",
        "changeSuccess": "Données personnelles enregistrées avec succès.",
        "companyData": {
          "editTitle": "Informations sur l'entreprise",
          "title": "Données concernant la société"
        },
        "dateOfBirth": "Date de naissance",
        "loginData": {
          "accountLocked": "Votre accès est bloqué pendant 30 minutes. Veuillez réessayer plus tard ou réinitialiser votre mot de passe.",
          "currentEmail": "Adresse e-mail actuelle",
          "currentEmailError": "Vérifiez votre adresse e-mail.",
          "currentPassword": "Mot de passe actuel",
          "emailChangeSuccess": "Adresse e-mail modifiée avec succès.",
          "emailInUseError": "Il semble que cet e-mail soit déjà utilisé, utilisez-en un autre.",
          "emailInvalid": "Adresse e-mail non valide.",
          "newEmail": "Saisir la nouvelle adresse e-mail",
          "newPassword": "Nouveau mot de passe",
          "passwordChangeSuccess": "Mot de passe modifié avec succès.",
          "passwordEnter": "Saisir le mot de passe",
          "passwordError": "Vérifiez votre saisie.",
          "passwordTitle": "Votre mot de passe"
        }
      },
      "security": {
        "2fa": {
          "alerts": {
            "appSetupSuccess": "Vérification par app enregistrée avec succès.",
            "smsSetupSuccess": "Vérification par SMS enregistrée avec succès."
          },
          "changeOption": "Changer l'option de connexion 2FA",
          "changePhonenumber": {
            "error": "Le numéro de téléphone n'est pas valide. Veuillez réessayer.",
            "text": "Vous utilisez actuellement <0>{{phoneNumber}}</0> pour 2FA. Si vous souhaitez remplacer votre 2FA par un nouveau numéro, veuillez indiquer le numéro de téléphone sur lequel vous souhaitez recevoir votre code de vérification.",
            "title": "Changer de numéro de téléphone"
          },
          "confirmStandard": {
            "error": "Nous n'avons pas pu supprimer votre 2FA. Essayer à nouveau.",
            "steps": {
              "2": {
                "title": "Confirmez avec votre nom que vous comprenez les risques liés à la désactivation de la 2FA."
              }
            },
            "subtitle": "Désactivez et continuez avec la connexion par défaut",
            "success": "Votre 2FA a été supprimé.",
            "text1": "Pour confirmer la désactivation de vos paramètres 2FA, veuillez signer avec votre nom ci-dessous.",
            "text2": "Assurez-vous de comprendre que votre compte ne sera pas aussi sécurisé qu’il devrait l’être.",
            "text3": "Vos codes de récupération deviendront obsolètes après la désactivation de 2FA. \nVous pouvez obtenir de nouveaux codes si vous réactivez les paramètres ultérieurement."
          },
          "description": "2FA vous permet de sécuriser davantage votre compte.",
          "disabledBecauseMagicLink": "Impossible avec la connexion par lien e-mail activée",
          "initialSetup": {
            "title": "Paramètres des options 2FA"
          },
          "method": {
            "app": "Application d'authentification"
          },
          "modal": {
            "description": "Veuillez entrer votre code 2FA ci-dessous pour vous vérifier.",
            "error": "Le code n'est pas valide. \nVeuillez réessayer.",
            "foundYourCode": "Vous avez trouvé votre code ?",
            "recoveryCode": "Code de récupération",
            "recoveryCodeDescription": "Si vous avez perdu l'accès à votre appareil 2FA, vous pouvez utiliser un code de récupération pour vous connecter. Veuillez conserver vos codes de récupération dans un endroit sûr.",
            "recoveryTitle": "Entrez votre code de récupération",
            "success": "Le code est valide.",
            "titleApp": "Entrez le code de vérification depuis votre application d'authentification",
            "titleSms": "Entrez le code de vérification depuis votre SMS",
            "unableToUse": "Impossible d'utiliser le code de vérification ?",
            "useUniqueCode": "Utiliser le code de récupération"
          },
          "qrCode": {
            "description": "Scannez le code QR ou copiez votre clé avec des appareils supplémentaires ou des applications d'authentification. Cela est particulièrement utile pour les clients qui partagent leur compte.",
            "title": "QR Code pour l'application 2FA"
          },
          "readMore": "Cliquez ici pour en savoir plus.",
          "readMoreUrl": "https://support.digitalrepublic.ch/fr/support/solutions/articles/33000290331",
          "title": "Authentification à deux facteurs (2FA)"
        },
        "buttons": {
          "activate": "Activer",
          "back": "Retour",
          "verify": "Vérifier"
        },
        "magicLink": {
          "description": "Si cette option est activée, vous pouvez vous connecter avec un lien sécurisé par e-mail – sans mot de passe.",
          "disabledBecauseTwoFactor": "Impossible avec la 2FA activée",
          "saveError": "Le paramètre n'a pas pu être enregistré. Veuillez réessayer.",
          "saveSuccess": "Votre paramètre a été enregistré.",
          "title": "Connexion par lien e-mail",
          "toggleTitle": "Autoriser la connexion par lien e-mail"
        }
      },
      "tabs": {
        "billingRecipients": "Destinataires de facture",
        "inbox": "Notifications",
        "paymentMethods": "Mode de paiement",
        "security": "Connexion"
      },
      "title": "Compte d'utilisateur"
    }
  },
  "translation": {
    "2fa": {
      "setup": {
        "options": {
          "authenticatorApp": {
            "title": "Application Authenticator"
          },
          "login": {
            "title": "Connexion par défaut"
          },
          "not-recommended": "Non recommandé",
          "secure": "Sécurisé",
          "sms": {
            "title": "Vérification par SMS"
          },
          "very-secure": "Très sécurisé"
        }
      }
    },
    "Common": {
      "checkout": {
        "dueOn": "dû le {{date}}",
        "summary": "Résumé",
        "thereafter": "Ensuite"
      },
      "companyName": "Digital Republic AG",
      "days": "Jours",
      "friendsWithBenefits": {
        "businessCustomer": "Les clients commerciaux ne peuvent pas participer à Friends with Benefits."
      },
      "generalForm": {
        "error": {
          "genericError": "Une erreur s'est produite. Si le problème persiste, veuillez réessayer dans une fenêtre de navigation privée.",
          "genericRegexError": "Veuillez saisir une valeur valide"
        },
        "fields": {
          "email": {
            "label": "Adresse e-mail"
          },
          "password": {
            "label": "Mot de passe"
          }
        },
        "validation": {
          "emailNotValid": "Veuillez saisir une adresse e-mail valide",
          "emailRequired": "Veuillez saisir une adresse e-mail",
          "passwordRequired": "Veuillez saisir un mot de passe"
        }
      },
      "label": {
        "back": "retour",
        "backToLogin": "Retour à la connexion",
        "cancel": "Annuler",
        "change": "Modifier",
        "complete": "Terminer",
        "continue": "Continuer",
        "delete": "Supprimer",
        "finish": "Terminer",
        "forward": "continuer",
        "gotIt": "Compris",
        "manage": "Gérer",
        "name": "Nom",
        "optional": "(optionnel)",
        "period": "Période",
        "personalDetails": "Données personnelles",
        "price": "Prix",
        "removeItem": "Retirer {{label}}",
        "save": "Enregistrer",
        "subscriptionName": "Nom de l'abonnement",
        "toShop": "Aller à la boutique"
      },
      "language": "Langue",
      "links": {
        "privacyPolicy": "https://digitalrepublic.ch/fr/datenschutz/",
        "rates": "https://digitalrepublic.ch/fr/apercu-des-tarifs/",
        "terms&Conditions": "https://digitalrepublic.ch/fr/allgemeine-geschaeftsbedingungen"
      },
      "logoName": "Digital Republic",
      "nothingFound": "Rien n'a été trouvé.",
      "products": {
        "esim": "eSIM",
        "friendsWithBenefits": "Friends with Benefits",
        "simCard": "Carte SIM",
        "watchSim": "Watch SIM"
      },
      "requirementStatus": {
        "met": "rempli",
        "notMet": "pas encore rempli"
      },
      "selected": "sélectionné",
      "stepStatus": {
        "done": "terminé",
        "in-progress": "en cours",
        "to-be-done": "à faire"
      },
      "support": "Support",
      "tariff": {
        "365days": "365 jours",
        "dataTelephonySmsCH": "Données, Téléphonie & SMS CH",
        "international": "International",
        "mbitMax": "Mbit/s max.",
        "options": "Options d'abonnement",
        "unlimited": "Illimité",
        "unlimitedLowercase": "illimité",
        "volumeGb": "{{volume}} Go"
      }
    },
    "Content": {
      "goodToKnow": "Bon à savoir",
      "periods": "Périodes"
    },
    "Error": {
      "404": {
        "backToThePortal": "Retour au portail",
        "text": "Oups, cette page ne semble pas exister. Nous sommes désolés que vous n'ayez pas trouvé ce que vous cherchiez. Cliquez ici pour revenir directement vers le portail clients.",
        "title": "Erreur 404"
      },
      "agentLogin": {
        "failed": "La connexion n'a pas fonctionné. Réessayez."
      },
      "eSimError": "Les informations eSIM n’ont pas pu être chargées. Veuillez réessayer plus tard.",
      "payment": {
        "expired": "Cette carte ne peut pas être débitée car sa date d'expiration est dépassée.",
        "expiredZero": "Cette carte ne peut pas être utilisée car sa date d'expiration est dépassée.",
        "fail": "Votre moyen de paiement n'a pas pu être débité.",
        "failZero": "Votre mode de paiement n'a pas pu être déposé.",
        "notValid": "Ce numéro de carte est invalide. Contrôlez votre saisie et réessayez.",
        "pleaseCheckData": "Vérifiez vos données ou contactez le fournisseur de votre mode de paiement.",
        "pleaseCheckInput": "Vérifiez votre saisie ou essayez un autre mode de paiement."
      },
      "roamingError": "Les données de roaming n’ont pas pu être chargées. Veuillez réessayer plus tard."
    },
    "Footer": {
      "customerNumber": "Numéro de client:",
      "customerPortal": {
        "label": "Portail client"
      },
      "dataProtection": {
        "label": "Politique de confidentialité"
      },
      "disclaimer": {
        "label": "Clause de non-responsabilité",
        "url": "https://digitalrepublic.ch/fr/haftungsausschluss-geistiges-eigentum/"
      },
      "imprint": {
        "label": "Mentions légales",
        "url": "https://digitalrepublic.ch/fr/impressum/"
      },
      "linksNavAriaLabel": "Liens de pied de page",
      "partnerPortal": {
        "label": "Portail partenaires"
      },
      "privacySettings": {
        "label": "Paramètres de confidentialité"
      },
      "socialLinksNavAriaLabel": "Liens vers les réseaux sociaux",
      "support": {
        "url": "https://support.digitalrepublic.ch/"
      },
      "termsConditions": {
        "label": "CG"
      },
      "website": {
        "label": "Site web",
        "url": "https://digitalrepublic.ch/fr/"
      }
    },
    "Header": {
      "welcomeHeadline": "Bienvenue dans le portail client"
    },
    "Icons": {
      "connection": "Connexion",
      "speed": "Vitesse"
    },
    "Languages": {
      "english": "Anglais",
      "french": "Français",
      "german": "Allemand",
      "language": ""
    },
    "Onboarding": {
      "sections": {
        "checkout": {
          "acceptTerms": "Oui, j'accepte les <0>conditions générales</0> et souhaite finaliser ma commande.",
          "alreadyAddedPaymentData": "Mode de paiement déjà enregistré.",
          "basketErrors": {
            "basketReloaded": "Votre commande n'a pas pu être finalisée et a été rechargée. Veuillez vérifier les informations et finaliser à nouveau votre commande.",
            "iccidMissing": "Aucune carte SIM n'est associée à votre commande. Veuillez saisir à nouveau votre carte SIM.",
            "mnpDataMissing": "Les informations de portage de votre numéro sont manquantes. Veuillez les saisir à nouveau.",
            "totalAmountChanged": "Le montant total de votre commande a changé. Veuillez vérifier le montant mis à jour et finaliser à nouveau votre commande."
          },
          "billingAccount": {
            "description": "Veuillez choisir un destinataire de facture existant ou en ajouter un nouveau.",
            "editHint": "Vous souhaitez modifier un destinataire de facture existant ? Rendez-vous dans <0>Destinataires de facture</0>.",
            "title": "Facturation"
          },
          "billingPeriod": {
            "description": "En cas de paiement annuel, un mois est gratuit.",
            "freeMonthBadge": "1 mois gratuit",
            "monthly": "Mensuel",
            "title": "Préférer payer annuellement ?",
            "yearly": "Annuel"
          },
          "choosePayment": "Ajoutez un mode de paiement pour ce paiement. Veuillez vous assurer que la fonction 3D Secure est activée pour votre carte de crédit.",
          "loading": "Votre commande est en cours de traitement.",
          "noCharge": "Pour des raisons de sécurité, un moyen de paiement doit être enregistré pour activer votre abonnement. Si vous avez déjà payé votre abonnement, nous ne débiterons pas votre moyen de paiement.",
          "paymentData": "Mode de paiement",
          "subtitleWhileHandling": "Votre paiement est en cours de traitement, un instant s'il vous plaît !",
          "summary": {
            "billingPeriod": "{{days}} jours",
            "callsTitle": "Appels EU/USA",
            "callsVolumeMinutes": "{{volume}} min.",
            "changeRate": "Modifier",
            "credit": "Crédit",
            "dataRoamingTitle": "Itinérance de données EU/USA",
            "defaultNames": {
              "dataPlan04": "Mon Flat 0.4",
              "dataPlan1": "Mon Flat 1",
              "dataPlan10": "Mon Flat 10",
              "dataPlan2000": "Mon Flat 2000",
              "dataPlan300": "Mon Flat 300",
              "dataPlan50": "Mon Flat 50",
              "flatMobileOne": "Mon Flat Mobile One",
              "flatMobileThree": "Mon Flat Mobile Three",
              "flatMobileTwo": "Mon Flat Mobile Two",
              "homeInternet4G": "Internet à domicile 4G",
              "homeInternet5G": "Internet à domicile 5G"
            },
            "deviceName": "Nom de l'appareil",
            "deviceNamePlaceholder": "L'iPhone de Sarah",
            "deviceType": "Type d'appareil",
            "discount": "Rabais",
            "durationDays_one": "{{count}} jour d'engagement",
            "durationDays_other": "{{count}} jours d'engagement",
            "durationMonths_one": "{{count}} mois d'engagement",
            "durationMonths_other": "{{count}} mois d'engagement",
            "errorDeviceName": "Veuillez saisir un nom d'appareil valide (min. 3 caractères).",
            "errorDeviceType": "Veuillez sélectionner un type d'appareil.",
            "esimHintText": "Votre eSIM sera disponible sur le portail une fois votre identité vérifiée.",
            "internationalRestriction": "Un document d'identité délivré en Suisse (passeport/carte d'identité ou permis de séjour) doit être utilisé lors de l'ID Check pour utiliser la téléphonie en itinérance.",
            "newNumberHint": "Vous recevrez un nouveau numéro de téléphone.",
            "newNumberTitle": "Nouveau numéro de téléphone",
            "nextDueOn": "arrive à échéance le {{date}}",
            "numberPortingIncluded": "avec portage de numéro",
            "numberPortingNotIncluded": "sans portage de numéro",
            "payOnce": "À payer <0>maintenant</0>",
            "payOnceValue": "à payer <0>maintenant</0> {{total}}",
            "payReoccuring": "À payer <0>chaque {{days}} jour</0>",
            "portedNumberHint": "Ce numéro sera conservé.",
            "portedNumberTitle": "Numéro de téléphone existant",
            "recurringCaption": "tous les {{days}} jours",
            "startingAfterPorting": "Après le portage du numéro",
            "startingOn": "dès {{date}}",
            "subtotal": "Sous-total",
            "switzerlandDataOnlyTitle": "Données 5G",
            "taxIncluded": "TVA 8.1% comprise",
            "total": "Total",
            "until_date": "(jusqu'au <0>{{date}}</0>)",
            "voiceOptionIncluded": "avec l'option Voice",
            "voiceOptionNotIncluded": "sans l'option Voice"
          }
        },
        "number-porting": {
          "afterContractEnds": "Après la fin du contrat",
          "beforeContractEnds": "Résiliation anticipée du contrat",
          "chooseWishDate": "Choisir une date souhaitée",
          "completed": "Numéro de portage terminé",
          "cost-warning": "Éventuellement, votre fournisseur peut vous facturer des frais supplémentaires. ",
          "currentContractType": "Type de contrat actuel",
          "currentNumber": "Numéro de téléphone actuel",
          "currentProvider": "Fournisseur actuel",
          "hintTitle": "Remarque",
          "msisdnAlreadyInUse": "Le numéro de téléphone existe déjà dans le système et ne peut pas être enregistré.",
          "msisdnSuspended": "Le numéro de téléphone a été suspendu et ne peut pas être transféré.",
          "numberFormat": "Le numéro de téléphone doit être saisi au format +41 (0) xx xxx xx xx.",
          "placeholder": {
            "currentNumber": "`+41 (0) __ ___ __ __",
            "currentProvider": "Sélectionnez un fournisseur",
            "wishDate": "AAAA-MM-JJ"
          },
          "postpaid": "Abonnement (facture mensuelle)",
          "prepaid": "Prépayé",
          "recommended": "conseillé",
          "steps": "Nous prendrons les mesures nécessaires. Vous n'avez pas besoin de résilier votre contrat avec votre fournisseur actuel.",
          "subHeadline": "Afin que nous puissions demander le transfert de votre numéro de téléphone, nous vous prions de nous fournir quelques renseignements sur votre fournisseur actuel. Ne vous inquiétez pas, le portage n'est effectué que si vous le souhaitez.",
          "termination": "Résiliation",
          "title": "Portage de numéro"
        },
        "personal-details": {
          "disabledFieldsHint": "Si vous souhaitez modifier les champs inactifs de vos données personnelles, vous pouvez contacter notre <0>équipe d'assistance</0>.",
          "form": {
            "formOfAddress": {
              "mr": "M.",
              "mrs": "Mme",
              "other": "Non précisé"
            },
            "hint": {
              "firstName": "Prénom selon pièce d’identité",
              "lastName": "Nom de famille selon pièce d’identité"
            },
            "label": {
              "addressSupplement": "Complément d'adresse",
              "city": "Ville",
              "company-street": "Rue (siège social)",
              "country": "Pays",
              "dateOfBirth": "Date de naissance*",
              "firstName": "Prénom selon pièce d’identité",
              "formOfAddress": "Titre",
              "houseNumber": "N°",
              "isBusinessAccount": "J'utilise ce compte à des fins professionnelles",
              "lastName": "Nom de famille selon pièce d’identité",
              "organizationForm": "Forme de la société",
              "organizationId": "ID de la société",
              "organizationName": "Nom de la société",
              "phone": "Numéro de téléphone en cas de questions",
              "street": "Rue",
              "zip": "Code postal"
            },
            "legalForms": {
              "1": "Entreprise individuelle",
              "10": "Fondation",
              "11": "Société publique",
              "2": "Société simple",
              "3": "Société collective",
              "4": "Société en commandite",
              "5": "SA",
              "6": "SàRL",
              "7": "Société en commandite par actions",
              "8": "Coopérative",
              "9": "Association"
            },
            "placeholder": {
              "dateOfBirth": "Date de naissance (jj / mm / aaaa)",
              "organizationId": "Identifiant de la société (UID)"
            },
            "validation": {
              "organizationId": "Vérifiez  l'UID saisi."
            }
          },
          "friendsWithBenefitsPopUp": {
            "cta1": "Créer un compte privé",
            "cta2": "Sortir du groupe",
            "text2": "Si vous créez un compte d'entreprise, vous serez retiré du groupe.",
            "text3": "Si vous êtes un client commercial et que vous souhaitez bénéficier de remises sur volume, vous pouvez contacter notre équipe d'assistance ou notre équipe de vente.",
            "title": "Attention !"
          }
        },
        "rate-selection": {
          "dontTakeNumber": "<strong>Non</strong>, je veux un <strong>nouveau</strong> numéro de téléphone.",
          "download": "Téléchargement",
          "mbitPerSecond": "{{value}} Mbit/s",
          "numberPortingHint": "Vous <0>ne pourrez pas</0> profiter de cette option par la suite.",
          "perMonth": "CHF par mois",
          "prechargedRateHint": "Vous pourrez modifier cet abonnement après la durée du contrat, dans votre espace client.",
          "roamingVolumeWithCalls": "{{volume}} Go + {{minutes}} min.",
          "roamingVolumeWithUnlimitedCalls": "{{volume}} Go + ∞ min.",
          "roamingZone": "en UE/USA",
          "tabs": {
            "dataOnly": "Data-only",
            "mobileAbos": "Mobile Abos"
          },
          "tariffHint": "Tous nos abonnements incluent des données <1>illimitées</1> <0>en Suisse</0>.",
          "upload": "Envoi",
          "yesTakeNumber": "<strong>Oui</strong>, je veux conserver mon <strong>courant</strong> numéro de téléphone actuel."
        },
        "sim-selection": {
          "dunningProcessOpenText": "Vous ne pouvez pas ajouter de nouveaux abonnements pour le moment, car votre compte fait l'objet d'une procédure de recouvrement. Veuillez régler vos factures en attente pour continuer.",
          "homepageLink": "https://digitalrepublic.ch/fr/",
          "noSimCardText": "Commandez une carte SIM dans notre boutique pour pouvoir lancer l'activation.",
          "noSimCardTitle": "Vous n'avez pas encore de carte SIM ?",
          "shopLink": "https://digitalrepublic.ch/fr/shop/?utm_source=aax_dr&utm_medium=reorder_link&utm_campaign=aax_reorder&utm_term=adddevice",
          "upgradeSimLimit": "Augmenter la limite",
          "upgradeSimLimitLink": "https://support.digitalrepublic.ch/fr/support/solutions/articles/33000287898-comment-puis-je-augmenter-le-nombre-maximum-de-cartes-sim"
        },
        "sim-verification": {
          "hint": {
            "header": "Numéros SIM et PUK",
            "text": "Vous trouverez votre numéro SIM (ICCID) et votre code PUK imprimés sur votre carte SIM."
          },
          "iccid": {
            "helpHint": "Où puis-je le trouver ?",
            "label": "Votre numéro SIM",
            "placeholder": "Entrez votre numéro SIM",
            "validation": {
              "badFormat": "Saisissez votre numéro SIM à 20 chiffres.",
              "invalid": "Le numéro SIM saisi n'a pas pu être attribué."
            }
          },
          "puk": {
            "label": "Votre code PUK",
            "placeholder": "Entrez votre PUK",
            "validation": {
              "badFormat": "Saisissez votre PUK à 8 chiffres.",
              "rejected": "Le code PUK saisi ne semble pas correct."
            }
          },
          "scanner": {
            "button": "Scanner le code-barres",
            "cameraError": "Impossible d'ouvrir la caméra. Veuillez vérifier les autorisations.",
            "hint": "Placez le code-barres de votre carte SIM dans la zone marquée.",
            "noBarcode": "Aucun code-barres détecté. Veuillez réessayer.",
            "scan": "Scanner maintenant",
            "scanning": "Scan en cours…",
            "title": "Scanner le numéro SIM"
          },
          "simAliasFlatHome": "Mon Flat Home",
          "subtitle": "Sous-titre de vérification SIM"
        }
      }
    },
    "Tile": {
      "label": {
        "activateSim": "Activer la carte SIM"
      }
    },
    "billingActionBlocked": {
      "text": "En raison d'une facturation en cours ou des paramètres de votre compte, il n'est actuellement pas possible de créer ou de modifier des destinataires de facture, ni de déplacer des abonnements. Une facturation peut durer jusqu'à 24 heures. Veuillez réessayer plus tard.",
      "title": "Modification actuellement impossible"
    },
    "clipboardField": {
      "copy": "Copier"
    },
    "countries": {
      "ABW": "Aruba",
      "AFG": "Afghanistan",
      "AGO": "Angola",
      "AIA": "Anguilla",
      "ALA": "Archipel d'Äland",
      "ALB": "Albanie",
      "AND": "Andorre",
      "ARE": "Émirats Arabes Unis",
      "ARG": "Argentine",
      "ARM": "Arménie",
      "ASM": "Samoa américaines",
      "ATA": "Antarctique",
      "ATF": "Terres australes et antarctiques françaises",
      "ATG": "Antigua-et-Barbuda",
      "AUS": "Australie",
      "AUT": "Autriche",
      "AZE": "Azerbaïdjan",
      "BDI": "Burundi",
      "BEL": "Belgique",
      "BEN": "Bénin",
      "BES": "Bonaire, Saint Eustache et Saba",
      "BFA": "Burkina Faso",
      "BGD": "Bangladesh",
      "BGR": "Bulgarie",
      "BHR": "Bahreïn",
      "BHS": "Bahamas",
      "BIH": "Bosnie Herzégovine",
      "BLM": "Saint Barthélemy",
      "BLR": "Biélorussie",
      "BLZ": "Bélize",
      "BMU": "Bermudes",
      "BOL": "Bolivie ",
      "BRA": "Brésil",
      "BRB": "Barbade",
      "BRN": "Brunei Darussalam",
      "BTN": "Bhoutan",
      "BVT": "Île Bouvet",
      "BWA": "Botswana",
      "CAF": "République centrafricaine",
      "CAN": "Canada",
      "CCK": "Îles Cocos (Keeling)",
      "CHE": "Suisse",
      "CHL": "Chili",
      "CHN": "Chine",
      "CIV": "Côte d'Ivoire",
      "CMR": "Cameroun",
      "COD": "Congo, République démocratique du",
      "COG": "Congo-Brazzaville",
      "COK": "Îles Cook",
      "COL": "Colombie",
      "COM": "Comores",
      "CPV": "Cap-Vert",
      "CRI": "Costa Rica",
      "CUB": "Cuba",
      "CUW": "Curaçao",
      "CXR": "L'île de noël",
      "CYM": "Îles Caïmans",
      "CYP": "Chypre",
      "CZE": "Tchéquie",
      "DEU": "Allemagne",
      "DJI": "Djibouti",
      "DMA": "Dominique",
      "DNK": "Danemark",
      "DOM": "République dominicaine",
      "DZA": "Algérie",
      "ECU": "Équateur",
      "EGY": "Égypte",
      "ERI": "Érythrée",
      "ESH": "Sahara occidental",
      "ESP": "Espagne",
      "EST": "Estonie",
      "ETH": "Éthiopie",
      "FIN": "Finlande",
      "FJI": "Fidji",
      "FLK": "Îles Falkland (Malouines)",
      "FRA": "France",
      "FRO": "Îles Féroé",
      "FSM": "Micronésie (États fédérés de)",
      "GAB": "Gabon",
      "GBR": "Royaume-Uni de Grande-Bretagne et d'Irlande du Nord",
      "GEO": "Géorgie",
      "GGY": "Guernesey",
      "GHA": "Ghana",
      "GIB": "Gibraltar",
      "GIN": "Guinée",
      "GLP": "Guadeloupe",
      "GMB": "Gambie",
      "GNB": "Guinée-Bissau",
      "GNQ": "Guinée Équatoriale",
      "GRC": "Grèce",
      "GRD": "Grenade",
      "GRL": "Groenland",
      "GTM": "Guatemala",
      "GUF": "Guyane Française",
      "GUM": "Guam",
      "GUY": "Guyane",
      "HKG": "Hong Kong",
      "HMD": "Île Heard et îles McDonald",
      "HND": "Honduras",
      "HRV": "Croatie",
      "HTI": "Haïti",
      "HUN": "Hongrie",
      "IDN": "Indonésie",
      "IMN": "île de Man",
      "IND": "Inde",
      "IOT": "Territoire britannique de l'océan Indien",
      "IRL": "Irlande",
      "IRN": "Iran ",
      "IRQ": "Irak",
      "ISL": "Islande",
      "ISR": "Israël",
      "ITA": "Italie",
      "JAM": "Jamaïque",
      "JEY": "Jersey",
      "JOR": "Jordanie",
      "JPN": "Japon",
      "KAZ": "Kazakhstan",
      "KEN": "Kenya",
      "KGZ": "Kirghizistan",
      "KHM": "Cambodge",
      "KIR": "Kiribati",
      "KNA": "Saint-Christophe-et-Niévès",
      "KOR": "Corée du sud",
      "KWT": "Koweit",
      "LAO": "Laos",
      "LBN": "Liban",
      "LBR": "Libéria",
      "LBY": "Libye",
      "LCA": "Sainte-Lucie",
      "LIE": "Liechtenstein",
      "LKA": "Sri Lanka",
      "LSO": "Lesotho",
      "LTU": "Lituanie",
      "LUX": "Luxembourg",
      "LVA": "Lettonie",
      "MAC": "Macao",
      "MAF": "Saint Martin (partie française)",
      "MAR": "Maroc",
      "MCO": "Monaco",
      "MDA": "Moldavie, République de",
      "MDG": "Madagascar",
      "MDV": "Maldives",
      "MEX": "Mexique",
      "MHL": "Iles Marshall",
      "MKD": "Macédoine du Nord",
      "MLI": "Mali",
      "MLT": "Malte",
      "MMR": "Birmanie",
      "MNE": "Monténégro",
      "MNG": "Mongolie",
      "MNP": "Îles Mariannes du Nord",
      "MOZ": "Mozambique",
      "MRT": "Mauritanie",
      "MSR": "Montserrat",
      "MTQ": "Martinique",
      "MUS": "Maurice",
      "MWI": "Malawi",
      "MYS": "Malaisie",
      "MYT": "Mayotte",
      "NAM": "Namibie",
      "NCL": "Nouvelle Calédonie",
      "NER": "Niger",
      "NFK": "l'ile Norfolk",
      "NGA": "Nigeria",
      "NIC": "Nicaragua",
      "NIU": "Niué",
      "NLD": "Pays-Bas",
      "NOR": "Norvège",
      "NPL": "Népal",
      "NRU": "Nauru",
      "NZL": "Nouvelle-Zélande",
      "OMN": "Oman",
      "PAK": "Pakistan",
      "PAN": "Panama",
      "PCN": "Îles Pitcairn",
      "PER": "Pérou",
      "PHL": "Philippines",
      "PLW": "Palaos",
      "PNG": "Papouasie Nouvelle Guinée",
      "POL": "Pologne",
      "PRI": "Porto Rico",
      "PRK": "Corée du nord",
      "PRT": "Portugal",
      "PRY": "Paraguay",
      "PSE": "Palestine, État de",
      "PYF": "Polynésie française",
      "QAT": "Qatar",
      "REU": "Île de la Réunion",
      "ROU": "Roumanie",
      "RUS": "Fédération Russe",
      "RWA": "Rwanda",
      "SAU": "Arabie Saoudite",
      "SDN": "Soudan",
      "SEN": "Sénégal",
      "SGP": "Singapour",
      "SGS": "Géorgie du Sud et îles Sandwich du Sud",
      "SHN": "Sainte-Hélène, Ascension et Tristan da Cunha",
      "SJM": "Svalbard et Jan Mayen",
      "SLB": "Les îles Salomon",
      "SLE": "Sierra Leone",
      "SLV": "Le Salvador",
      "SMR": "Saint-Marin",
      "SOM": "Somalie",
      "SPM": "Saint-Pierre-et-Miquelon",
      "SRB": "Serbie",
      "SSD": "Soudan du sud",
      "STP": "Sao Tomé-et-Principe",
      "SUR": "Suriname",
      "SVK": "Slovaquie",
      "SVN": "Slovénie",
      "SWE": "Suède",
      "SWZ": "Eswatini",
      "SXM": "Sint Maarten (partie néerlandaise)",
      "SYC": "Les Seychelles",
      "SYR": "République arabe syrienne",
      "TCA": "îles Turques-et-Caïques",
      "TCD": "Tchad",
      "TGO": "Togo",
      "THA": "Thaïlande",
      "TJK": "Tadjikistan",
      "TKL": "Tokélaou",
      "TKM": "Turkménistan",
      "TLS": "Timor oriental",
      "TON": "Tonga",
      "TTO": "Trinité-et-Tobago",
      "TUN": "Tunisie",
      "TUR": "Turquie",
      "TUV": "Tuvalu",
      "TWN": "Taïwan",
      "TZA": "Tanzanie",
      "UGA": "Ouganda",
      "UKR": "Ukraine",
      "UMI": "Îles mineures éloignées des États-Unis",
      "URY": "Uruguay",
      "USA": "États-Unis d'Amérique",
      "UZB": "Ouzbékistan",
      "VAT": "Vatican",
      "VCT": "Saint-Vincent-et-les-Grenadines",
      "VEN": "Venezuela ",
      "VGB": "Îles Vierges (britanniques)",
      "VIR": "Îles Vierges (États-Unis)",
      "VNM": "Vietnam",
      "VUT": "Vanuatu",
      "WLF": "Wallis et Futuna",
      "WSM": "Samoa",
      "XKX": "Kosovo",
      "YEM": "Yémen",
      "ZAF": "Afrique du Sud",
      "ZMB": "Zambie",
      "ZWE": "Zimbabwe"
    },
    "label": {
      "hidePassword": "Masquer le mot de passe",
      "hint": {
        "newPassword": "Votre mot de passe doit contenir des lettres majuscules et minuscules, des caractères spéciaux, des chiffres et entre 8 à 30 caractères.",
        "password": "Confirmez votre nouvelle adresse e-mail avec votre mot de passe."
      },
      "showPassword": "Afficher le mot de passe",
      "validation": {
        "email": "Saisissez une adresse e-mail valide, s'il vous plaît.",
        "invalidBirthdate": "Entrez une date de naissance valide.",
        "maxLength": "Vous avez dépassé le maximum de {{max}} caractères autorisés.",
        "password": "Mot de passe incorrect. Votre mot de passe doit être composé de majuscules, minuscules, caractères spéciaux et chiffres et comprendre entre 8 et 30 caractères.",
        "phone": "Saisissez votre numéro de téléphone au format +xxxxxxxxxxxx.",
        "phoneBackend": "Ce numéro de téléphone n'est pas valide. Contrôlez votre saisie.",
        "phoneNoPlus": "Votre numéro de téléphone doit commencer par 07 ou 00.",
        "required": "Ce champ est obligatoire.",
        "zip": "Entrez un code postal valide."
      }
    },
    "links": {
      "isMyDeviceESIMCompatible": "https://support.digitalrepublic.ch/en/support/solutions/articles/33000256600-do-i-own-an-esim-compatible-device-",
      "supportHomeLink": "https://support.digitalrepublic.ch/fr/support/home"
    },
    "newWelcome": {
      "initialPasswordSetup": {
        "confirmPasswordLabel": "Répéter le nouveau mot de passe",
        "errors": {
          "genericError": "Une erreur s'est produite. Veuillez réessayer.",
          "unauthorized": "Votre session a expiré. Veuillez vous reconnecter via le lien reçu par e-mail.",
          "userNotFound": "Nous n'avons pas trouvé votre compte. Veuillez vous reconnecter via le lien reçu par e-mail."
        },
        "headline": "Bienvenue sur Digital Republic",
        "passwordLabel": "Nouveau mot de passe",
        "title": "Définir le mot de passe"
      },
      "logInForm": {
        "forgotPassword": "Mot de passe oublié?",
        "invalidCredentialsError": "Mot de passe ou e-mail adresse incorrect",
        "noAccount": "Vous n'avez pas encore de compte?",
        "registerNow": "S'inscrire maintenant",
        "submitButton": "Se connecter"
      },
      "magicLink": {
        "errors": {
          "consumeFailed": "La connexion a échoué. Veuillez réessayer ou vous connecter avec votre mot de passe.",
          "expiredLink": "Ce lien a expiré. Demandez un nouveau lien de connexion sur l'écran de connexion.",
          "invalidLink": "Ce lien de connexion est invalide",
          "notAllowed": "La connexion via un lien e-mail n'est pas activée pour votre compte. Vous pouvez modifier ce paramètre dans les réglages.",
          "rateLimited": "Vous avez demandé trop de liens de connexion. Veuillez réessayer plus tard.",
          "requestFailed": "La connexion via un lien e-mail n'est pas disponible pour le moment. Veuillez réessayer plus tard ou vous connecter avec votre mot de passe.",
          "usedLink": "Ce lien a déjà été utilisé"
        },
        "linkOnLogin": "Se connecter via un lien e-mail",
        "request": {
          "backToPasswordLogin": "Se connecter avec un mot de passe",
          "description": "Saisissez votre adresse e-mail. Nous vous enverrons un lien sécurisé pour vous connecter au portail client.",
          "title": "Connexion"
        },
        "sent": {
          "message": "Si un compte existe pour cette adresse e-mail, vous recevrez sous peu un e-mail contenant un lien de connexion. Pour des raisons de sécurité, ce lien n'est valable que pendant une durée limitée."
        }
      },
      "registerForm": {
        "acceptTerms": "Accepter les <2>Conditions Générales</2> et la <1>Politique de Confidentialité</1> *",
        "accountExists": "Vous avez déjà un compte?",
        "confirmPassword": {
          "label": "Confirmer le mot de passe"
        },
        "error": {
          "emailAlreadyInUse": "Un compte avec cette adresse e-mail existe déjà",
          "invalidEmailFormat": "Ce format d'adresse e-mail n'est pas pris en charge. Veuillez saisir une adresse e-mail valide."
        },
        "logInNow": "Se connecter maintenant",
        "passwordHint": "Votre mot de passe doit répondre aux critères suivants:",
        "passwordRequirements": {
          "disallowedCharacter": "Ce caractère n'est pas autorisé : {{character}}",
          "disallowedCharacters": "Ces caractères ne sont pas autorisés : {{characters}}",
          "minLength": "8-30 caractères",
          "numberRequired": "Au moins un chiffre (0-9)",
          "spaceCharacter": "espace",
          "specialCharacter": "Au moins un caractère spécial (=+-^$*.[]{}()?\"!@#%&/\\,><':;|_~`)",
          "upperLowercase": "Au moins une lettre minuscule et une lettre majuscule (a–z, A–Z)"
        },
        "title": "S'inscrire",
        "uiFeedback": {
          "registrationSuccess": "Votre compte a été créé avec succès"
        },
        "validation": {
          "acceptTerms": "Veuillez accepter les Conditions Générales et la Politique de Confidentialité",
          "confirmPasswordRequired": "Veuillez confirmer votre mot de passe",
          "passwordNoMatch": "Les mots de passe ne correspondent pas"
        }
      }
    },
    "sessionExpired": {
      "text": "Pour des raisons de sécurité, vous avez été déconnecté",
      "title": "Votre session a expiré"
    }
  }
}
